/* JOLI POT, configurateur (assets/jp-configurateur.js). Réglages venant de Shopify : window.JP_LIQ, écrit par snippets/jp-configurateur.liquid juste avant ce fichier. */
(function () {
  if (!window.JP_LIQ) return;
  var JP_LIQ = window.JP_LIQ;

(function () {
  /* ===== RÉGLAGES ===== */
  /* Titres des étapes, repérés par un mot-clé contenu dans le nom de l'option (majuscules sans importance) */
  var LIBELLES = {
    'modèle': 'Choisissez votre modèle',
    'taille': 'Sélectionnez la taille souhaitée',
    'coupelle': 'Optez pour une coupelle',
    'graine': 'Choisissez vos graines',
    'message': 'Choisissez votre message'
  };
  var LIBELLE_MESSAGE = 'Votre message';
  var LIBELLE_PLUS = 'Complétez votre Joli Pot';
  var LIBELLE_MISE_A_JOUR = 'Mettre à jour mon pot';
  var TEXTE_BOITE_INCLUSE = 'Jolie boîte cadeau incluse';
  /* Étapes masquées quand il ne reste qu'un seul choix possible */
  var MASQUER_SI_UNIQUE = ['taille', 'coupelle'];
  /* Nombre max de caractères par taille (en cm). null = pas de limite */
  var LIMITES = { '5': JP_LIQ.lim5, '6': JP_LIQ.lim6, '8': JP_LIQ.lim8, '11': JP_LIQ.lim11, '13': JP_LIQ.lim13 };
  /* Limite pour une fiche sans option Taille (le kit, 8 cm) */
  var LIMITE_SANS_TAILLE = JP_LIQ.lim8;
  /* Carte à planter : ID de la variante et prix en centimes */
  /* Repris automatiquement du produit carte choisi dans les paramètres du thème */
  var CARTE_VARIANT_ID = 55921142792516;
  var CARTE_PRIX = 550;
  /* Nombre max de caractères pour le texte de la carte à planter */
  var LIMITE_CARTE = JP_LIQ.limCarte;
  /* Aperçu de la carte : styles d'écriture proposés (police, nom affiché, taille max en % de la largeur de carte) */
  var STYLES_CARTE = [
    { police: 'Orwell', nom: 'Joli Pot', plafond: 4.2 },
    { police: 'Great Vibes', nom: 'Élégant', plafond: 6 },
    { police: 'Sacramento', nom: 'Doux', plafond: 6.5 },
    { police: 'Caveat', nom: 'Naturel', plafond: 5 },
    { police: 'Dancing Script', nom: 'Joyeux', plafond: 5 }
  ];
  var CA_TITRE_STYLE = "Style d'écriture";
  var CA_TITRE_SIGNATURE = 'Signature';
  var CA_AIDE_SIGNATURE = 'facultatif, écrite sous le cœur';
  var CA_EXEMPLE_SIGNATURE = 'Ex. Marie';
  var CA_VIDE = 'Votre message ici';
  /* Astuce sous le compteur de la carte ('' pour ne rien afficher) */
  var CA_ASTUCE = "Astuce : allez à la ligne (touche Entrée) pour composer la mise en page de votre choix, l'aperçu suit en direct.";
  var CA_VOIR_PHOTO = 'Voir la carte en situation';
  var CA_PROP_STYLE = "Style d'écriture";
  var CA_PROP_SIGNATURE = 'Signature';
  /* Textes de la fenêtre photo */
  var POPUP_OK = "C'est celui-là, je continue";
  var POPUP_AUTRE = 'Voir les autres modèles';
  /* Conseils de taille : intro au-dessus des boutons, puis 2 lignes dans chaque bouton (clé = taille en cm) */
  var INTRO_TAILLE = [];
  var CONSEILS_TAILLE = {
    '8': ['Plante en pot\n6 cm max'],
    '11': ['Plante en pot\n9 cm max'],
    '13': ['Plante en pot\n11 cm max']
  };
  /* Note sous les coupelles ('' pour ne rien afficher) */
  var NOTE_COUPELLE = "Tous les pots possèdent un trou de drainage sur le fond pour laisser l'eau s'écouler.";
  /* Suspension en macramé (petit plus) */
  var NOM_BOITE = 'Emballage\ncadeau';
  var NOM_CARTE = 'Carte\nà planter';
  var SUSP_NOM = 'Suspension\nmacramé';
  var SUSP_TITRE_POPUP = 'Choisissez votre suspension';
  var SUSP_ASTUCE = "Pensez à la coupelle pour éviter d'abîmer la suspension.";
  var SUSP_AUCUNE = 'Non merci';
  var SUSP_RETIRER = 'Retirer';
  var SUSP_AJOUTER = 'Ajouter';
  var SUSP_GARDER = 'Garder';
  var SUSP_AJOUT_COUPELLE = 'Ajouter la coupelle';
  var SUSP_COUPELLE_OK = 'Coupelle ajoutée ✓';
  var SUSP_ANNULER = 'Annuler';
  var SUSP_VOIR = 'Voir les modèles';
  var SUSP_CHANGER = 'Changer de modèle';
  /* Liens qui ouvrent une photo de la galerie en grand */
  var LIEN_PHOTO_TAILLES = 'Voir les 3 tailles en photo';
  var LIEN_PHOTO_COUPELLES = 'Voir les coupelles en photo';
  /* Titre au-dessus du champ du message ('' pour ne rien afficher) */
  var TITRE_CHAMP = 'Le texte qui sera écrit sur votre pot :';
  /* Texte grisé dans le champ du message */
  var PLACEHOLDER_MESSAGE = 'Votre message à écrire sur le pot...';
  /* Prix sous le titre tant qu'aucun modèle n'est choisi */
  var PREFIXE_PRIX = 'À partir de ';
    /* Mention affichée pour les modèles dont le nom contient le texte indiqué */
  var MENTIONS = [
    { contient: 'fleurs séchées', texte: 'Collaboration Les Rêves de Louise X Joli Pot' }
  ];
  /* Idées de messages : un message par ligne, entre les accents graves ` ` */
    var OCCASIONS = JP_LIQ.occasions;
  /* ===== FIN DES RÉGLAGES ===== */
  /* Police Orwell intégrée (rien à déposer dans le thème) */
  var POLICE_ORWELL_URL = JP_LIQ.orwell;
  /* Polices d'écriture des aperçus, hébergées dans le thème (assets/jp-police-*.woff2) */
  var POLICES_JP = {
    'Sacramento': JP_LIQ.sacramento,
    'Great Vibes': JP_LIQ.greatVibes,
    'Caveat': JP_LIQ.caveat,
    'Dancing Script': JP_LIQ.dancing
  };

  /* Lu tout de suite, avant que le thème ne réécrive l'adresse de la page */
  var JP_EDIT = JP_LIQ.edit;

  function init() {
    var cfgEl = document.getElementById('jp-config');
    var form = document.querySelector('form.ProductForm');
    if (!cfgEl || !form || form.dataset.jpReady) return;
    form.dataset.jpReady = '1';

    var cfg = JSON.parse(cfgEl.textContent);
    if (cfg.carteId) { CARTE_VARIANT_ID = cfg.carteId; CARTE_PRIX = cfg.cartePrix; }
    /* Position d'une option repérée par mot-clé (ex. 'taille', 'coupelle') */
    function optIdx(motCle) {
      for (var k = 0; k < cfg.options.length; k++) {
        if (String(cfg.options[k]).toLowerCase().indexOf(motCle) > -1) return k;
      }
      return -1;
    }
    function contientUn(nom, liste) {
      var n = String(nom || '').toLowerCase();
      return liste.some(function (m) { return n.indexOf(m) > -1; });
    }
    function libelleDe(nom) {
      var n = String(nom || '').toLowerCase();
      for (var cle in LIBELLES) { if (n.indexOf(cle) > -1) return LIBELLES[cle]; }
      return nom;
    }
    var isPot = cfg.handle === cfg.potHandle;
    var isKit = cfg.handle === cfg.kitHandle;
    var radios = Array.prototype.slice.call(form.querySelectorAll('.SizeSwatch__Radio, .ColorSwatch__Radio'));
    var texte = document.getElementById('votre-texte-personnalise');
    var labTexte = document.querySelector('label[for="votre-texte-personnalise"]');
    var blocTexte = texte ? texte.closest('.ProductForm__Label') : null;
    var boutonPanier = form.querySelector('.ProductForm__AddToCart');
    var blocBoite = document.getElementById('jp-boite');
    var modeEdit = JP_EDIT;
    var blocsOptions = [];
    var finEls = [];
    var finAffichee = false;
    var msgFait = false;
    var labPlus = null;
    var occupe = false;
    var compteur = null;
    var popOuvert = false;
    var pop = null;
    var suspChoisie = null;
    var coupelleAvant = null;
    var blocSusp = null;
    var grilleExtras = null;
    var extrasChoisis = {};

    /* Le thème reconstruit parfois le bouton : on va toujours chercher le bouton actuel */
    function boutonActuel() { return form.querySelector('.ProductForm__AddToCart'); }

    /* Empêche le saut vers la photo quand on clique une option */
    var verrouY = null;
    var verrouJusqua = 0;
    function verrouActif() { return popOuvert || (verrouY !== null && Date.now() < verrouJusqua); }
    function poserVerrou() { verrouY = window.pageYOffset; verrouJusqua = Date.now() + 2500; }
    form.addEventListener('change', function (e) {
      if (!popOuvert && e.target.matches && e.target.matches('.SizeSwatch__Radio, .ColorSwatch__Radio')) poserVerrou();
    }, true);
    ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (!popOuvert) verrouY = null; }, { passive: true });
    });
    var scrollToNatif = window.scrollTo.bind(window);
    window.scrollTo = function () { if (verrouActif()) return; return scrollToNatif.apply(window, arguments); };
    var scrollIntoViewNatif = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () { if (verrouActif()) return; return scrollIntoViewNatif.apply(this, arguments); };
    /* Le thème fait aussi défiler la page vers la photo de la taille choisie par d'autres moyens : on les bloque aussi */
    ['scroll', 'scrollBy'].forEach(function (nomF) {
      var natif = window[nomF];
      if (typeof natif === 'function') window[nomF] = function () { if (verrouActif()) return; return natif.apply(window, arguments); };
    });
    var descTop = Object.getOwnPropertyDescriptor(Element.prototype, 'scrollTop');
    if (descTop && descTop.set) [document.documentElement, document.body].forEach(function (el) {
      try {
        Object.defineProperty(el, 'scrollTop', { configurable: true, get: function () { return descTop.get.call(this); }, set: function (v) { if (verrouActif()) return; descTop.set.call(this, v); } });
      } catch (e) {}
    });
    window.addEventListener('scroll', function () {
      if (verrouActif() && verrouY !== null && Math.abs(window.pageYOffset - verrouY) > 2) scrollToNatif(window.pageXOffset, verrouY);
    }, { passive: true });

    function selection() {
      var s = {};
      radios.forEach(function (r) { if (r.checked) s[r.dataset.optionPosition] = r.value; });
      return s;
    }

    function correspond(pos, val, sel, dispoSeulement) {
      return cfg.variants.some(function (v) {
        if (dispoSeulement && !v.available) return false;
        for (var p = 1; p < pos; p++) { if (v['option' + p] !== sel[p]) return false; }
        return v['option' + pos] === val;
      });
    }

    function choisir(r) {
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function radiosPosition(pos) {
      return radios.filter(function (r) { return r.dataset.optionPosition === String(pos); });
    }

    /* Bouton "Mettre à jour mon pot" en mode modification */
    function libelleEdit() {
      if (!modeEdit) return;
      setTimeout(function () {
        var bp = boutonActuel();
        var s = bp ? bp.querySelector('span') : null;
        if (s) s.textContent = LIBELLE_MISE_A_JOUR;
      }, 150);
    }

    /* Prix affiché = pot + boîte + carte (le bouton tient compte de la quantité) */
    function formater(c) {
      return (c % 100 ? (c / 100).toFixed(2).replace('.', ',') : String(c / 100)) + ' €';
    }

    /* Le thème réécrit le prix à sa façon (« €39 ») à chaque option : on le remet au bon format
       avant même que l'écran ne s'affiche, pour éviter le clignotement */
    var prixEcrits = { titre: null, bouton: null }, obsPrix = null;
    function surveillerPrix() {
      if (obsPrix || !window.MutationObserver) return;
      obsPrix = new MutationObserver(function () {
        var t = document.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
        var bp = boutonActuel(), b = bp ? bp.querySelector('[data-money-convertible]') : null;
        if ((t && prixEcrits.titre !== null && t.textContent !== prixEcrits.titre) || (b && prixEcrits.bouton !== null && b.textContent !== prixEcrits.bouton)) majPrix();
      });
      var meta = document.querySelector('.ProductMeta');
      if (meta) obsPrix.observe(meta, { childList: true, subtree: true, characterData: true });
      obsPrix.observe(form, { childList: true, subtree: true, characterData: true });
    }
    function majPrix() {
      surveillerPrix();
      var champId = form.querySelector('[name="id"]');
      if (!champId) return;
      var v = cfg.variants.filter(function (x) { return String(x.id) === String(champId.value); })[0];
      if (!v) return;
      var caseCarte = document.getElementById('add-seed-card');
      var caseBoite = document.getElementById('jp-boite-check');
      var avecBoite = !!(caseBoite && caseBoite.checked && blocBoite && blocBoite.style.display !== 'none');
      var avecCarte = !!(caseCarte && caseCarte.checked);
      var champQte = form.querySelector('.QuantitySelector__CurrentQuantity');
      var q = champQte ? (parseInt(champQte.value, 10) || 1) : 1;
      var unitaire = v.price + (avecBoite ? (cfg.boitePrix || 0) : 0) + (suspChoisie && blocSusp && blocSusp.style.display !== 'none' ? suspChoisie.prix : 0)
        + (cfg.extras || []).reduce(function (t, x) { return t + (extrasChoisis[x.id] ? x.prix : 0); }, 0)
        + (typeof window.jpPrixSupp === 'function' ? (window.jpPrixSupp() || 0) : 0);
      var carte = avecCarte ? CARTE_PRIX : 0;
      var bp = boutonActuel();
      var prixBouton = bp ? bp.querySelector('[data-money-convertible]') : null;
      if (prixBouton) { prixBouton.textContent = formater((unitaire + carte) * q); prixEcrits.bouton = prixBouton.textContent; }
      var prixTitre = document.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
      var aucunModele = isPot && !modeEdit && blocsOptions[0] && !blocsOptions[0].dataset.jpFait;
      if (prixTitre) {
        if (aucunModele) {
          var mini = Math.min.apply(null, cfg.variants.map(function (x) { return x.price; }));
          prixTitre.textContent = PREFIXE_PRIX + formater(mini);
        } else {
          prixTitre.textContent = formater(unitaire + carte);
        }
        prixEcrits.titre = prixTitre.textContent;
      }
      majLivraison(aucunModele ? 0 : unitaire + carte, q, aucunModele);
      majBarreMob(aucunModele ? PREFIXE_PRIX + formater(Math.min.apply(null, cfg.variants.map(function (x) { return x.price; }))) : formater((unitaire + carte) * q), aucunModele);
    }

    /* Barre collante en bas sur mobile : prix à jour en permanence.
       Le bouton panier n'y apparaît qu'une fois toutes les étapes remplies (vrai bouton visible et actif). */
    var barreMob = null, boutonVisible = false, plusVu = false, pretDepuis = 0;
    function panierPret() {
      var bp = boutonActuel();
      return !!(bp && !bp.disabled && !bp.classList.contains('jp-cache') && bp.offsetParent !== null);
    }
    function barreMobile() {
      if (barreMob || !boutonActuel()) return barreMob;
      barreMob = document.createElement('div');
      barreMob.className = 'jp-barre-mob';
      barreMob.innerHTML = '<span class="jp-barre-mob__fil" hidden><i></i></span><div class="jp-barre-mob__prix"><small>Votre Joli Pot</small><strong></strong><small class="jp-barre-mob__liv" hidden></small></div><button type="button" class="jp-barre-mob__btn" hidden>Ajouter au panier</button>';
      document.body.appendChild(barreMob);
      /* Bouton de la barre : si la cliente n'a pas encore vu les petits plus (emballage, carte...), on les lui montre d'abord ;
         sinon on ajoute directement au panier, sans détour */
      barreMob.querySelector('button').addEventListener('click', function () {
        if (!panierPret()) return;
        var zonePlus = plus && !plus.classList.contains('jp-cache') && plus.offsetParent !== null ? plus : null;
        if (zonePlus && !plusVu) {
          plusVu = true;
          verrouY = null; verrouJusqua = 0;
          scrollToNatif({ top: zonePlus.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
          return;
        }
        boutonActuel().click();
      });

      var bp0 = boutonActuel();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { boutonVisible = e[0].isIntersecting; majBarreMob(); }, { threshold: 0.2 }).observe(bp0);
      }
      if ('MutationObserver' in window) {
        new MutationObserver(function () { majBarreMob(); }).observe(bp0, { attributes: true, attributeFilter: ['class', 'disabled', 'style'] });
      }
      return barreMob;
    }
    function majBarreMob(prix, aucunModele) {
      var b = barreMobile(); if (!b) return;
      if (prix) b.querySelector('strong').textContent = prix;
      /* Le bouton n'apparaît que si le panier est prêt depuis un instant (évite le flash pendant un changement de modèle) */
      var pret = panierPret();
      if (!pret) pretDepuis = 0;
      else if (!pretDepuis) { pretDepuis = Date.now(); setTimeout(function () { majBarreMob(); }, 650); pret = false; }
      else if (Date.now() - pretDepuis < 600) pret = false;
      var btn = b.querySelector('button');
      btn.hidden = !pret;
      if (pret) {
        var bp = boutonActuel();
        var lib = (bp.querySelector('span') || bp).textContent.replace(/\s*[-–·]?\s*[0-9][0-9\s.,]* ?€.*$/, '').trim();
        btn.textContent = lib || 'Ajouter au panier';
      }
      /* visible dès que le vrai bouton n'est pas à l'écran (caché tant que les étapes ne sont pas finies, ou hors champ) */
      b.classList.toggle('is-visible', !(pret && boutonVisible));
      if (livArgs && !livEnCours) majLivraison.apply(null, livArgs);
    }

    /* Livraison offerte : encadré sous le bouton panier + info dans la barre collante
       (réglages : Paramètres du thème > Joli Pot · Panier) */
    var livEl = null, livArgs = null, livEnCours = false;
    function remplirLiv(t, L, reste) { return String(t || '').split('[seuil]').join(formater(L.seuil)).split('[reste]').join(formater(reste)).split('[panier]').join(formater(L.panier || 0)); }
    /* Montant du panier relu en direct (évite un chiffre périmé si le panier a changé dans un autre onglet) */
    function relirePanier() {
      if (!cfg.liv || !window.fetch) return;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var pro = (cfg.liv.tagPro || 'pro').toLowerCase();
        var estPro = (c.items || []).some(function (it) { return (it.product_type || '').toLowerCase() === pro; });
        if (estPro) { cfg.liv = null; } else { cfg.liv.panier = c.total_price || 0; }
        if (livArgs) majLivraison.apply(null, livArgs);
      }).catch(function () {});
    }
    relirePanier();
    window.addEventListener('pageshow', function (e) { if (e.persisted) relirePanier(); });
    /* Texte coupé en deux lignes équilibrées : après « : » s'il y en a un, sinon après la première virgule */
    function deuxLignes(el, t) {
      el.textContent = '';
      var i = t.indexOf(' : '), n = 3;
      if (i < 0) { i = t.indexOf(', '); n = 2; }
      if (i < 8 || i > t.length - 8) { el.textContent = t; return; }
      el.appendChild(document.createTextNode(t.slice(0, i + n - 1)));
      el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(t.slice(i + n)));
    }
    function majLivraison(unite, q, aucunModele) {
      livArgs = [unite, q, aucunModele];
      var L = cfg.liv, b = barreMob;
      var off = !L || !L.seuil || modeEdit;
      if (off) {
        if (livEl) livEl.hidden = true;
        if (b) { b.querySelector('.jp-barre-mob__liv').hidden = true; b.querySelector('.jp-barre-mob__fil').hidden = true; }
        return;
      }
      var panier = L.panier || 0, sel = (aucunModele ? 0 : unite) * q, total = panier + sel;
      var reste = Math.max(0, L.seuil - total), ok = total >= L.seuil, k;
      if (ok) k = (panier > 0 && sel < L.seuil && L.okp) ? 'okp' : 'ok';
      else if (aucunModele || !unite) k = 'base';
      else if (q === 1 && panier === 0 && unite * 2 >= L.seuil && L.deux) k = 'deux';
      else k = (panier > 0 && L.restep) ? 'restep' : 'reste';
      var pct = Math.min(100, Math.round(total * 100 / L.seuil)) + '%';
      /* Barre collante : texte court + filet de progression */
      if (b) {
        var lb = b.querySelector('.jp-barre-mob__liv'), fil = b.querySelector('.jp-barre-mob__fil');
        lb.textContent = remplirLiv((L.court || {})[k] || L[k], L, reste);
        lb.hidden = !lb.textContent; lb.classList.toggle('is-ok', ok);
        fil.hidden = false; fil.classList.toggle('is-ok', ok); fil.querySelector('i').style.width = pct;
      }
      /* Encadré sous le bouton : seulement quand le bouton est affiché */
      var bp = boutonActuel(); if (!bp) return;
      if (!livEl) {
        livEl = document.createElement('div'); livEl.className = 'jp-liv';
        livEl.innerHTML = '<p class="jp-liv__txt"></p><div class="jp-liv__barre"><i></i></div>';
      }
      if (livEl.previousSibling !== bp) bp.parentNode.insertBefore(livEl, bp.nextSibling);
      var txt = remplirLiv(L[k], L, reste);
      deuxLignes(livEl.querySelector('.jp-liv__txt'), (ok ? '✓ ' : '') + txt);
      livEl.querySelector('.jp-liv__barre i').style.width = pct;
      livEl.classList.toggle('jp-liv--ok', ok);
      livEnCours = true;
      livEl.hidden = !txt || bp.classList.contains('jp-cache') || bp.offsetParent === null;
      livEnCours = false;
    }

    function majPrixPlusTard() { setTimeout(majPrix, 200); }

    /* Limite de caractères selon la taille choisie */
    function limiteActuelle() {
      var i = optIdx('taille');
      if (i < 0) return LIMITE_SANS_TAILLE;
      var val = selection()[String(i + 1)];
      var m = val ? val.match(/\d+/) : null;
      return m && LIMITES[m[0]] ? LIMITES[m[0]] : null;
    }

    function majLimite() {
      if (!texte || !compteur) return;
      var lim = limiteActuelle();
      var nb = texte.value.length;
      if (lim) { texte.maxLength = lim; } else { texte.removeAttribute('maxlength'); }
      compteur.textContent = lim ? nb + ' / ' + lim + ' caractères' : nb + (nb > 1 ? ' caractères' : ' caractère');
      compteur.classList.toggle('is-trop', !!lim && nb > lim);
      document.querySelectorAll('.jp-idees__msg').forEach(function (b) {
        b.disabled = !!lim && b.textContent.length > lim;
        b.title = b.disabled ? 'Trop long pour cette taille' : '';
      });
    }

    /* Numérotation des étapes visibles, avec pastille */
    function poserEtape(l, n, texte) {
      var num = l.querySelector(':scope > .jp-num');
      var tit = l.querySelector(':scope > .jp-tit');
      if (!num) {
        Array.prototype.slice.call(l.childNodes).forEach(function (c) { if (c.nodeType === 3) c.remove(); });
        num = document.createElement('span'); num.className = 'jp-num';
        tit = document.createElement('span'); tit.className = 'jp-tit';
        l.insertBefore(tit, l.firstChild);
        l.insertBefore(num, tit);
        l.classList.add('jp-etape');
      }
      num.textContent = n;
      tit.textContent = texte;
    }
    function numeroter() {
      var n = 0;
      form.querySelectorAll('.ProductForm__Option--labelled > .ProductForm__Label').forEach(function (l) {
        if (!l.dataset.jpNom) {
          var t = l.firstChild;
          if (!t || t.nodeType !== 3) return;
          l.dataset.jpNom = t.textContent.trim().replace(/:$/, '').trim();
        }
        var nom = l.dataset.jpNom;
        if (!nom) return;
        var bloc = l.closest('.ProductForm__Option');
        if (bloc && bloc.style.display === 'none') return;
        n++;
        poserEtape(l, n, libelleDe(nom));
      });
      if (labTexte && !cfg.occasion) poserEtape(labTexte, ++n, LIBELLE_MESSAGE);
      if (labPlus) poserEtape(labPlus, ++n, LIBELLE_PLUS);
    }

    /* Parcours progressif : une étape apparaît quand la précédente est faite */
    function neutraliser(b) {
      var ref = b.querySelector('.SizeSwatch__Radio:not(:checked) + .SizeSwatch, .ColorSwatch__Radio:not(:checked) + .ColorSwatch');
      if (!ref) return;
      var cs = window.getComputedStyle(ref);
      b.style.setProperty('--jp-bord', cs.borderTopColor);
      b.style.setProperty('--jp-texte', cs.color);
      b.style.setProperty('--jp-fond', cs.backgroundColor);
    }

    function mentionModele(val) {
      var v = String(val || '').toLowerCase();
      var m = MENTIONS.filter(function (x) { return v.indexOf(x.contient.toLowerCase()) > -1; })[0];
      return m ? m.texte : '';
    }

        function appliquerFin() {
      finEls.forEach(function (el) { el.classList.toggle('jp-cache', !finAffichee); });
      var aide = document.getElementById('jp-aide-etapes');
      var repere = plus || boutonActuel();
      if (!aide && repere && repere.parentNode) {
        aide = document.createElement('p');
        aide.id = 'jp-aide-etapes';
        aide.className = 'jp-aide-etapes';
        repere.parentNode.insertBefore(aide, repere);
      }
      if (aide) {
        var etapeMessage = blocTexte && !blocTexte.classList.contains('jp-cache');
        aide.textContent = etapeMessage
          ? "Écrivez ou choisissez votre message pour accéder au bouton d'achat."
          : "Choisissez vos options, le bouton d'achat apparaîtra ensuite.";
        aide.style.display = finAffichee ? 'none' : '';
      }
      var bp = boutonActuel();
      if (bp) bp.classList.toggle('jp-cache', !finAffichee);
    }

    function majEtapes() {
      var ouvert = true;
      blocsOptions.forEach(function (b) {
        if (b.style.display === 'none') { b.classList.remove('jp-cache', 'jp-attente'); return; }
        b.classList.toggle('jp-cache', !ouvert);
        var attente = ouvert && !b.dataset.jpFait;
        b.classList.toggle('jp-attente', attente);
        if (attente) neutraliser(b);
        if (!b.dataset.jpFait) ouvert = false;
      });
      if (blocTexte) blocTexte.classList.toggle('jp-cache', !ouvert);
      if (ouvert && texte && texte.value.trim()) msgFait = true;
      finAffichee = ouvert && (msgFait || !texte);
            appliquerFin();
      setTimeout(appliquerFin, 200);
    }

    /* 1. Masquer les combinaisons qui n'existent pas */
    function majOptions(depart) {
      occupe = true;
      var sel = selection();
      for (var pos = 2; pos <= 3; pos++) {
        var groupe = radiosPosition(pos);
        if (!groupe.length) continue;
        var ok = false;
        var visibles = 0;
        groupe.forEach(function (r) {
          var existe = correspond(pos, r.value, sel, false);
          var li = r.closest('li');
          if (li) li.style.display = existe ? '' : 'none';
          if (existe) visibles++;
          if (existe && r.checked && (!depart || correspond(pos, r.value, sel, true))) ok = true;
        });
        if (!ok) {
          var cible = groupe.filter(function (r) { return correspond(pos, r.value, sel, true); })[0]
                   || groupe.filter(function (r) { return correspond(pos, r.value, sel, false); })[0];
          if (cible) { choisir(cible); sel = selection(); }
        }
        var blocOption = groupe[0].closest('.ProductForm__Option');
        var nomOption = cfg.options[pos - 1];
        if (blocOption) {
          blocOption.style.display = (contientUn(nomOption, MASQUER_SI_UNIQUE) && visibles <= 1) ? 'none' : '';
        }
      }
      occupe = false;
      numeroter();
      majLimite();
      majEtapes();
      libelleEdit();
      majPrixPlusTard();
    }

    /* Fenêtre photo en grand quand on choisit un modèle */
    function prixModele(val) {
      var prix = cfg.variants.filter(function (v) { return v.option1 === val; }).map(function (v) { return v.price; });
      if (!prix.length) return '';
      var min = Math.min.apply(null, prix);
      var txt = (min / 100).toFixed(2).replace('.', ',') + ' €';
      return (Math.max.apply(null, prix) > min ? 'À partir de ' : '') + txt;
    }

    function tailleModele(val) {
      var i = optIdx('taille');
      if (i < 0) return '';
      var tailles = [];
      cfg.variants.forEach(function (v) {
        var t = v['option' + (i + 1)];
        if (v.option1 === val && tailles.indexOf(t) < 0) tailles.push(t);
      });
      return tailles.length === 1 ? 'Taille unique ' + tailles[0] : '';
    }

    function fermerPopup(continuer) {
      if (!pop) return;
      pop.hidden = true;
      popOuvert = false;
      document.documentElement.classList.remove('jp-pop-ouvert');
      verrouY = null;
      if (continuer) {
        majEtapes();
        var cands = blocsOptions.slice(1).concat(blocTexte ? [blocTexte] : []);
        var suite = cands.filter(function (el) { return !el.classList.contains('jp-cache') && el.style.display !== 'none'; })[0];
        if (suite) scrollToNatif({ top: suite.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
      }
    }

    function creerPopup() {
      pop = document.createElement('div');
      pop.className = 'jp-pop';
      pop.hidden = true;
      pop.innerHTML = '<div class="jp-pop__boite" role="dialog" aria-modal="true">' +
        '<button type="button" class="jp-pop__fermer" aria-label="Fermer">&times;</button>' +
        '<img class="jp-pop__img" alt="">' +
                '<p class="jp-pop__nom"></p>' +
        '<p class="jp-pop__collab"></p>' +
        '<p class="jp-pop__prix"></p>' +
        '<div class="jp-pop__actions"><button type="button" class="jp-pop__ok"></button><button type="button" class="jp-pop__autre"></button></div>' +
        '</div>';
      pop.querySelector('.jp-pop__ok').textContent = POPUP_OK;
      pop.querySelector('.jp-pop__autre').textContent = POPUP_AUTRE;
      document.body.appendChild(pop);
      pop.addEventListener('click', function (e) { if (e.target === pop) fermerPopup(false); });
      pop.querySelector('.jp-pop__fermer').addEventListener('click', function () { fermerPopup(false); });
      pop.querySelector('.jp-pop__autre').addEventListener('click', function () { fermerPopup(false); });
      pop.querySelector('.jp-pop__ok').addEventListener('click', function () { fermerPopup(true); });
      document.addEventListener('keydown', function (e) { if (popOuvert && e.key === 'Escape') fermerPopup(false); });
    }

    function ouvrirPopup(val) {
      var im = cfg.potStyleImages ? cfg.potStyleImages[val] : null;
      if (!im || !im.grande) return;
      if (!pop) creerPopup();
      var img = pop.querySelector('.jp-pop__img');
      img.src = im.grande;
      img.alt = val;
      pop.querySelector('.jp-pop__nom').textContent = val;
            var collab = mentionModele(val);
      var pCollab = pop.querySelector('.jp-pop__collab');
      pCollab.textContent = collab;
      pCollab.style.display = collab ? '' : 'none';
      var infoTaille = tailleModele(val);
      pop.querySelector('.jp-pop__prix').textContent = prixModele(val) + (infoTaille ? ' · ' + infoTaille : '');
      if (verrouY === null) verrouY = window.pageYOffset;
      popOuvert = true;
      document.documentElement.classList.add('jp-pop-ouvert');
      pop.hidden = false;
      pop.querySelector('.jp-pop__ok').focus({ preventScroll: true });
    }

    /* Fiche rapide d'un modèle : grande photo et infos clés, ouverte par la loupe de la vignette */
    var FICHES = String(cfg.fiches || '').split(/\r?\n/).map(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      return (p.length >= 3 && p[0] && p[1]) ? { cle: p[0].toLowerCase(), titre: p[1], texte: p.slice(2).join(' | ') } : null;
    }).filter(Boolean);
    /* Joli pot doré : édition limitée jusqu'au 26 décembre, avec le nombre de jours restants */
    function compteDore() {
      var j = Math.ceil((new Date(2026, 11, 26, 23, 59, 59) - new Date()) / 86400000);
      return j < 1 ? '' : (j === 1 ? 'dernier jour pour le commander !' : 'plus que ' + j + ' jours pour l\'offrir');
    }
    function infosModele(nom) {
      var n = String(nom || '').toLowerCase();
      return FICHES.filter(function (f) { return n.indexOf(f.cle) > -1; });
    }
    var fen = null;
    /* Fenêtre ouverte : la page derrière ne défile plus, mais sa barre de défilement reste en place (rien ne bouge) */
    function bloquerDefilement(e) {
      if (!document.documentElement.classList.contains('jp-pop-ouvert')) return;
      var boite = e.target.closest ? e.target.closest('.jp-fen__boite, .jp-pop__boite') : null;
      if (boite && boite.scrollHeight > boite.clientHeight + 1) return;
      if (e.cancelable) e.preventDefault();
    }
    document.addEventListener('wheel', bloquerDefilement, { passive: false });
    document.addEventListener('touchmove', bloquerDefilement, { passive: false });
    function bloquerPage(oui) {
      document.documentElement.classList.toggle('jp-pop-ouvert', oui);
    }
    function fermerFiche() {
      if (!fen || fen.hidden) return;
      fen.hidden = true; popOuvert = false; bloquerPage(false); verrouY = null;
    }
    function creerFiche() {
      fen = document.createElement('div');
      fen.className = 'jp-fen'; fen.hidden = true;
      fen.setAttribute('role', 'dialog'); fen.setAttribute('aria-modal', 'true'); fen.setAttribute('aria-labelledby', 'jp-fen-t');
      fen.innerHTML = '<div class="jp-fen__boite jp-fiche"><span class="jp-poignee" aria-hidden="true"></span>'
        + '<button class="jp-fen__x" type="button" aria-label="Fermer">×</button>'
        + '<div class="jp-galerie"><div class="jp-galerie__grande"></div><div class="jp-galerie__vign"></div></div>'
        + '<div class="jp-fen__fiche"><h2 id="jp-fen-t"></h2><p class="jp-fen__modele"></p><div class="jp-fen__badges"></div>'
        + '<p class="jp-fen__prix"></p><dl class="jp-infos"></dl><div class="jp-fen__cta"></div></div></div>';
      document.body.appendChild(fen);
      fen.addEventListener('click', function (e) { if (e.target === fen || e.target.closest('.jp-fen__x')) fermerFiche(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermerFiche(); });
    }
    function ouvrirFiche(nom) {
      if (!fen) creerFiche();
      var estKitV = nom === cfg.kitLabel;
      var im = (cfg.potStyleImages || {})[nom];
      var vues = estKitV ? (cfg.kitPhotos || []) : ((im && im.photos && im.photos.length) ? im.photos : (im ? [{ p: im.petite, g: im.grande }] : []));
      if (!vues.length && estKitV && cfg.kitImage) vues = [{ p: cfg.kitImage, g: cfg.kitImage }];
      var grande = fen.querySelector('.jp-galerie__grande'), vign = fen.querySelector('.jp-galerie__vign');
      function voir(i) {
        grande.innerHTML = vues[i] ? '<img src="' + vues[i].g + '" alt="">' : '';
        if (vues[i]) grande.querySelector('img').alt = nom;
        vign.querySelectorAll('button').forEach(function (b, j) { b.classList.toggle('is-actif', j === i); });
      }
      vign.innerHTML = '';
      if (vues.length > 1) vues.forEach(function (v, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.innerHTML = '<img src="' + v.p + '" alt="" loading="lazy">'; b.addEventListener('click', function () { voir(i); }); vign.appendChild(b);
      });
      voir(0);
      fen.querySelector('#jp-fen-t').textContent = nom;
      fen.querySelector('.jp-fen__modele').textContent = estKitV ? '' : mentionModele(nom);
      var badges = fen.querySelector('.jp-fen__badges'); badges.innerHTML = '';
      if (cfg.best && cfg.bestTxt && nom === cfg.best) { var bb = document.createElement('span'); bb.className = 'jp-best'; bb.textContent = cfg.bestTxt; badges.appendChild(bb); }
      var oldDore = fen.querySelector('.jp-fen__dore'); if (oldDore) oldDore.remove();
      if (/dor[ée]/i.test(nom)) {
        var bl = document.createElement('span'); bl.className = 'jp-best jp-best--limite'; bl.textContent = 'Édition limitée'; badges.appendChild(bl);
        var cd = compteDore();
        if (cd) {
          var pd = document.createElement('p'); pd.className = 'jp-fen__dore';
          pd.style.cssText = 'margin:10px 0 0;padding:10px 14px;border-radius:var(--jp-arrondi,8px);background:#f6ecd6;color:#6b4e12;font-size:14px;line-height:1.45';
          pd.innerHTML = 'Disponible jusqu\'au <strong>26 décembre</strong> : ' + cd.replace(/(\d+ jours)/, '<strong>$1</strong>') + (/!$/.test(cd) ? '' : '.');
          badges.parentNode.insertBefore(pd, badges.nextSibling);
        }
      }
      var infoTaille = estKitV ? '' : tailleModele(nom);
      fen.querySelector('.jp-fen__prix').textContent = estKitV ? (cfg.kitPrix ? formater(cfg.kitPrix) : '') : prixModele(nom) + (infoTaille ? ' · ' + infoTaille : '');
      var dl = fen.querySelector('.jp-infos'); dl.innerHTML = '';
      infosModele(estKitV ? 'kit' : nom).forEach(function (f) {
        var d = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = f.titre; dd.textContent = f.texte; d.appendChild(dt); d.appendChild(dd); dl.appendChild(d);
      });
      var cta = fen.querySelector('.jp-fen__cta'); cta.innerHTML = '';
      var radio = isPot ? radiosPosition(1).filter(function (r) { return r.value === nom; })[0] : null;
      var lien = estKitV ? cfg.kitUrl : (!radio && cfg.potUrl ? cfg.potUrl + '?style=' + encodeURIComponent(nom) : null);
      var ok = document.createElement(lien ? 'a' : 'button');
      ok.className = 'jp-fen__ok';
      ok.textContent = estKitV ? (cfg.kitLabel ? 'Voir le ' + cfg.kitLabel.toLowerCase() : cfg.ficheBtn) : cfg.ficheBtn;
      if (lien) ok.href = lien; else ok.type = 'button';
      if (radio) ok.addEventListener('click', function () {
        fermerFiche();
        if (!radio.checked) choisir(radio);
        var b1 = radio.closest('.ProductForm__Option'); if (b1) b1.dataset.jpFait = '1';
        majPrixPlusTard();
        continuer();
      });
      cta.appendChild(ok);
      if (verrouY === null) verrouY = window.pageYOffset;
      popOuvert = true; bloquerPage(true); fen.hidden = false;
      fen.querySelector('.jp-fen__x').focus({ preventScroll: true });
    }
    /* Après le choix du modèle : on enchaîne vers l'étape suivante */
    function continuer() {
      majEtapes();
      setTimeout(function () {
        var cands = blocsOptions.slice(1).concat(blocTexte ? [blocTexte] : []);
        var suite = cands.filter(function (el) { return !el.classList.contains('jp-cache') && el.style.display !== 'none'; })[0];
        if (!suite) return;
        var h = suite.getBoundingClientRect().top;
        if (h > 0 && h < window.innerHeight * 0.7) return;
        verrouY = null; verrouJusqua = 0;
        scrollToNatif({ top: h + window.pageYOffset - 120, behavior: 'smooth' });
      }, 80);
    }

    /* Zoom simple sur une image (photo de la boîte cadeau) */
    function zoomer(src, depart) {
      var liste = Array.isArray(src) ? src.filter(Boolean) : [src];
      if (!liste.length) return;
      var idx = depart || 0;
      var z = document.createElement('div');
      z.className = 'jp-zoom';
      var im = document.createElement('img');
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'jp-zoom__x';
      x.setAttribute('aria-label', 'Fermer');
      x.innerHTML = '&times;';
      z.appendChild(im);
      z.appendChild(x);
      var compteurZ = null;
      function montrerZ(i) {
        idx = (i + liste.length) % liste.length;
        im.src = liste[idx];
        if (compteurZ) compteurZ.textContent = (idx + 1) + ' / ' + liste.length;
      }
      if (liste.length > 1) {
        ['prec', 'suiv'].forEach(function (sens) {
          var f = document.createElement('button');
          f.type = 'button';
          f.className = 'jp-zoom__fleche jp-zoom__fleche--' + sens;
          f.setAttribute('aria-label', sens === 'prec' ? 'Photo précédente' : 'Photo suivante');
          f.innerHTML = sens === 'prec' ? '&#8249;' : '&#8250;';
          f.addEventListener('click', function (e) { e.stopPropagation(); montrerZ(idx + (sens === 'prec' ? -1 : 1)); });
          z.appendChild(f);
        });
        compteurZ = document.createElement('span');
        compteurZ.className = 'jp-zoom__compteur';
        z.appendChild(compteurZ);
        var d0 = null;
        z.addEventListener('touchstart', function (e) { d0 = e.touches[0].clientX; }, { passive: true });
        z.addEventListener('touchend', function (e) {
          if (d0 === null) return;
          var dx = e.changedTouches[0].clientX - d0;
          if (Math.abs(dx) > 40) { z.dataset.glisse = '1'; montrerZ(idx + (dx < 0 ? 1 : -1)); }
          d0 = null;
        });
      }
      montrerZ(idx);
      function fermer() { z.remove(); document.removeEventListener('keydown', clavier); }
      function clavier(e) {
        if (e.key === 'Escape') fermer();
        if (liste.length > 1 && e.key === 'ArrowLeft') montrerZ(idx - 1);
        if (liste.length > 1 && e.key === 'ArrowRight') montrerZ(idx + 1);
      }
      z.addEventListener('click', function (e) {
        if (z.dataset.glisse) { delete z.dataset.glisse; return; }
        if (e.target !== im) fermer();
      });
      document.addEventListener('keydown', clavier);
      document.body.appendChild(z);
    }

    /* 2a. Fiche pot : bouton Kit à planter qui renvoie vers la fiche kit */
    var modeleDejaChoisi = false;
    var styleDemande = null;
    if (isPot) {
      var r1 = radiosPosition(1)[0];
      var ulStyle = r1 ? r1.closest('ul') : null;
      if (ulStyle && cfg.kitUrl) {
        var liKit = document.createElement('li');
        liKit.className = 'HorizontalList__Item';
        var aKit = document.createElement('a');
        aKit.className = 'SizeSwatch';
        aKit.href = cfg.kitUrl;
        aKit.textContent = cfg.kitLabel;
        liKit.appendChild(aKit);
        /* Le kit à planter en 3e position, juste après les deux Joli pots */
        var liApres = ulStyle.children[2];
        if (liApres) ulStyle.insertBefore(liKit, liApres); else ulStyle.appendChild(liKit);
      }
      var collabs = document.getElementById('jp-collabs');
      if (ulStyle && collabs && collabs.querySelector('.jp-collab-lien')) {
        ulStyle.parentNode.insertBefore(collabs, ulStyle.nextSibling);
        collabs.hidden = false;
      }
      var styleUrl = new URLSearchParams(window.location.search).get('style');
      if (styleUrl) {
        var rs = radiosPosition(1).filter(function (r) { return r.value === styleUrl; })[0];
        if (rs) styleDemande = rs;
      }
    }

    /* 2b. Fiche kit : même barre de modèles, avec Kit actif */
    if (isKit && cfg.potUrl && cfg.potStyles.length) {
      var bloc = document.createElement('div');
      bloc.className = 'ProductForm__Option ProductForm__Option--labelled';
      var lab = document.createElement('span');
      lab.className = 'ProductForm__Label';
      lab.textContent = 'Modèle:';
      var ul = document.createElement('ul');
      ul.className = 'SizeSwatchList HorizontalList HorizontalList--spacingTight';
      cfg.potStyles.forEach(function (s) {
        var li = document.createElement('li');
        li.className = 'HorizontalList__Item';
        var a = document.createElement('a');
        a.className = 'SizeSwatch';
        a.href = cfg.potUrl + '?style=' + encodeURIComponent(s);
        a.textContent = s;
        li.appendChild(a);
        ul.appendChild(li);
      });
      var liActif = document.createElement('li');
      liActif.className = 'HorizontalList__Item';
      var span = document.createElement('span');
      span.className = 'SizeSwatch jp-actif';
      span.textContent = cfg.kitLabel;
      liActif.appendChild(span);
      ul.appendChild(liActif);
      bloc.appendChild(lab);
      bloc.appendChild(ul);
      var zone = form.querySelector('.ProductForm__Variants');
      if (zone) zone.insertBefore(bloc, zone.firstChild);
    }

    /* 2c. Vignettes photo pour l'étape Modèle */
    if (isPot || isKit) {
      var imgs = cfg.potStyleImages || {};
      var ulModele = form.querySelector('.ProductForm__Variants .SizeSwatchList');
      if (ulModele) {
        ulModele.querySelectorAll('.SizeSwatch').forEach(function (el) {
          var nomModele = el.textContent.trim();
          var src = nomModele === cfg.kitLabel ? cfg.kitImage : (imgs[nomModele] ? imgs[nomModele].petite : null);
          if (!src) return;
          el.textContent = '';
          var cadreV = document.createElement('span');
          cadreV.className = 'jp-vignette__img';
          var img = document.createElement('img');
          img.src = src;
          img.alt = nomModele;
          img.loading = 'lazy';
          cadreV.appendChild(img);
          if (cfg.best && cfg.bestTxt && nomModele === cfg.best) {
            var best = document.createElement('span'); best.className = 'jp-best'; best.textContent = cfg.bestTxt; cadreV.appendChild(best);
          } else if (/dor[ée]/i.test(nomModele)) {
            /* Joli pot doré : proposé seulement pour Noël */
            var lim = document.createElement('span'); lim.className = 'jp-best jp-best--limite'; lim.textContent = 'Édition limitée'; cadreV.appendChild(lim);
          }
          var lp = document.createElement('span');
          lp.className = 'jp-loupe jp-mloupe'; lp.setAttribute('role', 'button'); lp.tabIndex = 0;
          lp.setAttribute('aria-label', 'Voir la fiche ' + nomModele);
          lp.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15.5 15.5 21 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
          lp.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ouvrirFiche(nomModele); });
          lp.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); ouvrirFiche(nomModele); } });
          cadreV.appendChild(lp);
          var sp = document.createElement('span');
          sp.textContent = nomModele;
          el.appendChild(cadreV);
          el.appendChild(sp);
          el.classList.add('jp-vignette');
        });
      }
    }

    /* Suspension en macramé : visible seulement si la taille choisie est compatible */
    function tailleActuelle() {
      var i = optIdx('taille');
      if (i < 0) return null;
      var val = selection()[String(i + 1)];
      var m = val ? val.match(/\d+/) : null;
      return m ? m[0] : null;
    }
    function suspCompatibles() {
      var t = tailleActuelle();
      var liste = [];
      if (!t) return liste;
      cfg.suspensions.forEach(function (sp) {
        var regle = sp.tailles.filter(function (x) { return x.split('=')[0] === t; })[0];
        if (!regle) return;
        var filtre = regle.split('=')[1] || '';
        var vars = sp.variantes.filter(function (va) { return va.dispo && (!filtre || va.titre.indexOf(filtre) > -1); });
        vars.forEach(function (va) {
          var suffixe = /default title/i.test(va.titre) ? '' : ' ' + va.titre.replace(/^Diam[eè]tre\s*/i, 'ø ');
          liste.push({ id: va.id, prix: va.prix, nom: sp.nom + suffixe, collab: sp.collab || '', image: sp.image, photos: (sp.photos && sp.photos.length) ? sp.photos : (sp.image ? [sp.image] : []) });
        });
      });
      return liste;
    }
    function majSuspension() {
      if (!blocSusp) return;
      var liste = suspCompatibles();
      if (suspChoisie && !liste.some(function (x) { return x.id === suspChoisie.id; })) suspChoisie = null;
      afficherEl(blocSusp, liste.length > 0);
      blocSusp.innerHTML = '';
      var zoneA0 = document.getElementById('jp-susp-astuce');
      if (!liste.length) { if (zoneA0) zoneA0.innerHTML = ''; blocSusp.classList.remove('is-choisi'); majPrixPlusTard(); return; }
      blocSusp.classList.toggle('is-choisi', !!suspChoisie);
      blocSusp.dataset.mode = liste.length === 1 ? 'direct' : 'fenetre';
      var it = liste.length === 1 ? liste[0] : suspChoisie;
      var photo = it ? (it.photos && it.photos[0]) || it.image : (cfg.suspensions[0] && cfg.suspensions[0].image);
      if (photo) {
        var cadre = document.createElement('span'); cadre.className = 'jp-extra__photo';
        var im = document.createElement('img'); im.src = photo; im.alt = it ? it.nom : SUSP_NOM; cadre.appendChild(im);
        if (liste.length === 1 && it.photos && it.photos.length) cadre.appendChild(loupe(it.photos.map(grandeImage)));
        blocSusp.appendChild(cadre);
      }
      var n = document.createElement('span'); n.className = 'jp-extra__nom';
      n.textContent = it ? it.nom : SUSP_NOM;
      blocSusp.appendChild(n);
      if (it && it.collab) { var cl = document.createElement('span'); cl.className = 'jp-pop__collab jp-extra__collab'; cl.textContent = it.collab; blocSusp.appendChild(cl); }
      var pr = document.createElement('small'); pr.className = 'jp-extra__prix';
      if (it) {
        pr.textContent = '+' + formater(it.prix);
      } else {
        var mini = Math.min.apply(null, liste.map(function (x) { return x.prix; }));
        pr.textContent = liste.length + ' modèles, dès ' + formater(mini);
      }
      blocSusp.appendChild(pr);
      if (liste.length > 1) {
        var voir = document.createElement('span'); voir.className = 'jp-extra__voir';
        voir.textContent = suspChoisie ? SUSP_CHANGER : SUSP_VOIR;
        blocSusp.appendChild(voir);
      }
      /* Astuce coupelle sous la grille quand une suspension est choisie */
      var zoneA = document.getElementById('jp-susp-astuce');
      if (zoneA) {
        zoneA.innerHTML = '';
        if ((suspChoisie || coupelleAvant) && blocSusp.style.display !== 'none') zoneA.appendChild(creerAstuceCoupelle());
      }
      majPrixPlusTard();
    }
    /* Astuce coupelle : seulement si la coupelle existe et n'est pas déjà choisie */
    function creerAstuceCoupelle() {
      var astuce = document.createElement('div');
      astuce.className = 'jp-susp__astuce';
      var posC = optIdx('coupelle') + 1;
      var avecC = posC > 0 ? radiosPosition(posC).filter(function (r) { return !/sans/i.test(r.value); })[0] : null;
      var liC = avecC ? avecC.closest('li') : null;
      if (!avecC || (liC && liC.style.display === 'none')) return astuce;
      if (!avecC.checked) coupelleAvant = null;
      if (avecC.checked && !coupelleAvant) return astuce;
      var sel = selection();
      var avantC = coupelleAvant || radiosPosition(posC).filter(function (r) { return r.checked; })[0];
      var cur = cfg.variants.filter(function (v) { return String(v.id) === String((form.querySelector('[name="id"]') || {}).value); })[0];
      var cible = cfg.variants.filter(function (v) {
        for (var k = 1; k <= 3; k++) {
          var attendu = k === posC ? avecC.value : sel[String(k)];
          if (attendu !== undefined && v['option' + k] !== attendu) return false;
        }
        return true;
      })[0];
      var diff = cur && cible ? cible.price - cur.price : 0;
      var afficherAstuce = function (ajoutee) {
        astuce.innerHTML = '';
        var ligne = document.createElement('p');
        ligne.className = 'jp-pop__prix';
        var lien = document.createElement('button');
        lien.type = 'button';
        lien.className = 'jp-lien-photo';
        if (!ajoutee) {
          ligne.appendChild(document.createTextNode(SUSP_ASTUCE + ' '));
          lien.textContent = SUSP_AJOUT_COUPELLE + (diff > 0 ? ' (+' + formater(diff) + ')' : '');
          lien.addEventListener('click', function (e) { e.stopPropagation(); coupelleAvant = avantC; choisir(avecC); afficherAstuce(true); });
        } else {
          ligne.appendChild(document.createTextNode(SUSP_COUPELLE_OK + ' · '));
          lien.textContent = SUSP_ANNULER;
          lien.addEventListener('click', function (e) { e.stopPropagation(); coupelleAvant = null; if (avantC) choisir(avantC); afficherAstuce(false); });
        }
        ligne.appendChild(lien);
        astuce.appendChild(ligne);
      };
      afficherAstuce(avecC.checked);
      return astuce;
    }

    function ouvrirSuspensions() {
      var liste = suspCompatibles();
      if (!liste.length) return;
      var fond = document.createElement('div');
      fond.className = 'jp-pop';
      var boite = document.createElement('div');
      boite.className = 'jp-pop__boite jp-pop__boite--susp';
      boite.setAttribute('role', 'dialog');
      boite.setAttribute('aria-modal', 'true');
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'jp-pop__fermer';
      x.setAttribute('aria-label', 'Fermer');
      x.innerHTML = '&times;';
      var titre = document.createElement('p');
      titre.className = 'jp-pop__nom';
      titre.textContent = SUSP_TITRE_POPUP;
      var grille = document.createElement('div');
      grille.className = 'jp-susp__grille';
      function fermer() {
        fond.remove();
        document.documentElement.classList.remove('jp-pop-ouvert');
        majExtras();
      }
      liste.forEach(function (it) {
        var b = document.createElement('div');
        b.className = 'jp-susp__carte' + (suspChoisie && suspChoisie.id === it.id ? ' is-choisi' : '');
        b.setAttribute('role', 'button');
        b.tabIndex = 0;
        if (it.photos.length) {
          var zone = document.createElement('div');
          zone.className = 'jp-carrousel';
          var im = document.createElement('img');
          im.alt = it.nom;
          var idx = 0;
          var points = document.createElement('div');
          points.className = 'jp-carrousel__points';
          var montrer = function (i) {
            idx = (i + it.photos.length) % it.photos.length;
            im.src = it.photos[idx];
            Array.prototype.forEach.call(points.children, function (pt, k) { pt.classList.toggle('is-actif', k === idx); });
          };
          zone.appendChild(im);
          if (it.photos.length > 1) {
            ['prec', 'suiv'].forEach(function (sens) {
              var f = document.createElement('button');
              f.type = 'button';
              f.className = 'jp-carrousel__fleche jp-carrousel__fleche--' + sens;
              f.setAttribute('aria-label', sens === 'prec' ? 'Photo précédente' : 'Photo suivante');
              f.innerHTML = sens === 'prec' ? '&#8249;' : '&#8250;';
              f.addEventListener('click', function (e) { e.stopPropagation(); montrer(idx + (sens === 'prec' ? -1 : 1)); });
              zone.appendChild(f);
            });
            it.photos.forEach(function () { points.appendChild(document.createElement('span')); });
            zone.appendChild(points);
            var depart = null;
            var mobileSusp = window.matchMedia('(max-width: 640px)').matches;
            zone.addEventListener('touchstart', function (e) { depart = mobileSusp ? null : e.touches[0].clientX; }, { passive: true });
            zone.addEventListener('touchend', function (e) {
              if (depart === null) return;
              var dx = e.changedTouches[0].clientX - depart;
              if (Math.abs(dx) > 40) { zone.dataset.glisse = '1'; montrer(idx + (dx < 0 ? 1 : -1)); }
              depart = null;
            });
          }
          montrer(0);
          var lp = loupe(function () { return it.photos.map(grandeImage); });
          lp.classList.add('jp-loupe--mobile');
          zone.appendChild(lp);
          b.appendChild(zone);
        }
        var n = document.createElement('span'); n.textContent = it.nom; b.appendChild(n);
        if (it.collab) { var cl = document.createElement('span'); cl.className = 'jp-pop__collab'; cl.textContent = it.collab; b.appendChild(cl); }
        var pr = document.createElement('small'); pr.textContent = '+' + formater(it.prix); b.appendChild(pr);
        var choisirCarte = function () { suspChoisie = it; fermer(); };
        b.addEventListener('click', function (e) {
          var z = b.querySelector('.jp-carrousel');
          if (z && z.dataset.glisse) { delete z.dataset.glisse; return; }
          /* Sur mobile, toucher la photo l'ouvre en grand au lieu de choisir */
          if (z && it.photos.length && window.matchMedia('(max-width: 640px)').matches && z.contains(e.target)) {
            zoomer(it.photos.map(grandeImage), 0);
            return;
          }
          choisirCarte();
        });
        b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choisirCarte(); } });
        grille.appendChild(b);
      });
      var astuce = creerAstuceCoupelle();
      var aucune = document.createElement('button');
      aucune.type = 'button';
      aucune.className = 'jp-pop__autre';
      aucune.textContent = suspChoisie ? SUSP_RETIRER : SUSP_AUCUNE;
      aucune.addEventListener('click', function () { suspChoisie = null; fermer(); });
      x.addEventListener('click', fermer);
      fond.addEventListener('click', function (e) { if (e.target === fond) fermer(); });
      boite.appendChild(x);
      /* Titre seulement s'il y a un vrai choix ; bouton d'ajout si une seule suspension */
      if (liste.length > 1) boite.appendChild(titre);
      boite.appendChild(grille);
      if (liste.length > 1) {
        var pts = document.createElement('div');
        pts.className = 'jp-susp__points';
        liste.forEach(function (x, k) {
          var pt = document.createElement('button');
          pt.type = 'button';
          pt.setAttribute('aria-label', x.nom);
          pt.addEventListener('click', function () {
            var c = grille.children[k];
            if (c) grille.scrollTo({ left: c.offsetLeft - grille.offsetLeft - (grille.clientWidth - c.clientWidth) / 2, behavior: 'smooth' });
          });
          pts.appendChild(pt);
        });
        var majPts = function () {
          var centre = grille.scrollLeft + grille.clientWidth / 2;
          var actif = 0, best = Infinity;
          Array.prototype.forEach.call(grille.children, function (c, k) {
            var d = Math.abs(c.offsetLeft - grille.offsetLeft + c.clientWidth / 2 - centre);
            if (d < best) { best = d; actif = k; }
          });
          Array.prototype.forEach.call(pts.children, function (pt, k) { pt.classList.toggle('is-actif', k === actif); });
        };
        grille.addEventListener('scroll', majPts, { passive: true });
        boite.appendChild(pts);
        setTimeout(majPts, 50);
      }
      boite.appendChild(astuce);
      var actions = document.createElement('div');
      actions.className = 'jp-susp__actions';
      if (liste.length === 1) {
        var ajout = document.createElement('button');
        ajout.type = 'button';
        ajout.className = 'jp-pop__ok';
        var dejaChoisie = suspChoisie && suspChoisie.id === liste[0].id;
        ajout.textContent = dejaChoisie ? SUSP_GARDER : SUSP_AJOUTER + ' (+' + formater(liste[0].prix) + ')';
        ajout.addEventListener('click', function () { suspChoisie = liste[0]; fermer(); });
        actions.appendChild(ajout);
      }
      actions.appendChild(aucune);
      boite.appendChild(actions);
      fond.appendChild(boite);
      document.body.appendChild(fond);
      document.documentElement.classList.add('jp-pop-ouvert');
    }
    /* Petits plus payants présentés en encadrés (les cases d'origine restent, masquées) */
    function masquerEl(el) { if (el) el.style.setProperty('display', 'none', 'important'); }
    function afficherEl(el, oui) { if (el) el.style.setProperty('display', oui ? 'flex' : 'none', 'important'); }
    /* Version grand format d'une image Shopify (pour le zoom) */
    function grandeImage(src) {
      if (!src) return src;
      /* Photo entière pour le zoom : largeur 1200, sans la hauteur ni le recadrage carré des vignettes */
      return src.replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?(?=\.[a-z]+(\?|$))/i, '_1200x').replace(/([?&])width=\d+/, '$1width=1200').replace(/&(height=\d+|crop=[a-z_]+)/gi, '').replace(/\?(height=\d+|crop=[a-z_]+)&?/gi, '?');
    }
    function loupe(src) {
      var l = document.createElement('span');
      l.className = 'jp-loupe';
      l.setAttribute('role', 'button');
      l.setAttribute('aria-label', 'Voir la photo en grand');
      l.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><line x1="15.5" y1="15.5" x2="21" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      l.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); zoomer(typeof src === 'function' ? src() : src, 0); });
      return l;
    }
    function carteExtra(cle, img, nom, sous, imgGrande) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jp-extra';
      b.dataset.cle = cle;
      if (img) {
        var cadre = document.createElement('span'); cadre.className = 'jp-extra__photo';
        var im = document.createElement('img'); im.src = img; im.alt = nom; im.loading = 'lazy';
        cadre.appendChild(im);
        cadre.appendChild(loupe([imgGrande || grandeImage(img)]));
        b.appendChild(cadre);
      }
      var n = document.createElement('span'); n.className = 'jp-extra__nom'; n.textContent = nom; b.appendChild(n);
      var pr = document.createElement('small'); pr.className = 'jp-extra__prix'; pr.textContent = sous; b.appendChild(pr);
      grilleExtras.appendChild(b);
      return b;
    }
    function majExtras() {
      if (!grilleExtras) return;
      var cb = document.getElementById('jp-boite-check');
      var cBoite = grilleExtras.querySelector('[data-cle="boite"]');
      if (cBoite) {
        afficherEl(cBoite, !!(blocBoite && blocBoite.style.display !== 'none'));
        cBoite.classList.toggle('is-choisi', !!(cb && cb.checked));
      }
      var cc = document.getElementById('add-seed-card');
      var cCarte = grilleExtras.querySelector('[data-cle="carte"]');
      if (cCarte) cCarte.classList.toggle('is-choisi', !!(cc && cc.checked));
      (cfg.extras || []).forEach(function (x) {
        var c = grilleExtras.querySelector('[data-cle="x' + x.id + '"]');
        if (c) c.classList.toggle('is-choisi', !!extrasChoisis[x.id]);
      });
      majSuspension();
      var visibles = Array.prototype.filter.call(grilleExtras.children, function (c) { return c.style.display !== 'none'; }).length;
      grilleExtras.style.setProperty('display', visibles ? 'grid' : 'none', 'important');
      majPrixPlusTard();
    }
    function construireExtras() {
      if (!plus) return;
      grilleExtras = document.createElement('div');
      grilleExtras.className = 'jp-extras';
      var carteOpt = document.getElementById('seed-card-option');
      if (carteOpt && carteOpt.parentNode === plus) plus.insertBefore(grilleExtras, carteOpt); else plus.appendChild(grilleExtras);
      var cb = document.getElementById('jp-boite-check');
      if (blocBoite && cb) {
        var thumbB = document.getElementById('jp-boite-thumb');
        var cBoite = carteExtra('boite', thumbB ? thumbB.src : null, NOM_BOITE, '+' + formater(cfg.boitePrix || 0), thumbB ? (thumbB.dataset.grande || grandeImage(thumbB.src)) : null);
        masquerEl(cb.closest('label') || document.querySelector('label[for="jp-boite-check"]'));
        masquerEl(thumbB);
        cBoite.addEventListener('click', function () { cb.click(); });
        cb.addEventListener('change', majExtras);
      }
      var cc = document.getElementById('add-seed-card');
      if (cc) {
        var thumbC = document.getElementById('seed-card-thumb');
        var cCarte = carteExtra('carte', thumbC ? thumbC.src : null, NOM_CARTE, '+' + formater(CARTE_PRIX), thumbC ? (thumbC.dataset.grande || grandeImage(thumbC.src)) : null);
        masquerEl(cc.closest('label') || document.querySelector('label[for="add-seed-card"]'));
        masquerEl(cc);
        masquerEl(thumbC);
        cCarte.addEventListener('click', function () { cc.click(); });
        cc.addEventListener('change', majExtras);
      }
      (cfg.extras || []).forEach(function (x) {
        var c = carteExtra('x' + x.id, x.image, x.nom, '+' + formater(x.prix));
        c.addEventListener('click', function () { extrasChoisis[x.id] = !extrasChoisis[x.id]; majExtras(); });
      });
      if (isPot && cfg.suspensions && cfg.suspensions.length) {
        blocSusp = carteExtra('susp', null, SUSP_NOM, '');
        blocSusp.addEventListener('click', function () {
          if (blocSusp.dataset.mode === 'direct') {
            var l1 = suspCompatibles()[0];
            suspChoisie = suspChoisie ? null : l1;
            majExtras();
          } else {
            ouvrirSuspensions();
          }
        });
        var zoneAstuce = document.createElement('div');
        zoneAstuce.id = 'jp-susp-astuce';
        grilleExtras.parentNode.insertBefore(zoneAstuce, grilleExtras.nextSibling);
        form.addEventListener('change', function (e) {
          if (e.target.matches && e.target.matches('.SizeSwatch__Radio, .ColorSwatch__Radio')) setTimeout(majExtras, 50);
        });
      }
      majExtras();
    }

    /* 3. Petits plus (cœur, cadeau, boîte, carte) regroupés après le message */
    var plus = document.querySelector('.product-form__item--checkboxes');
    if (plus && blocTexte) {
      blocTexte.parentNode.insertBefore(plus, blocTexte.nextSibling);
      labPlus = plus.querySelector('label');
      var carte = document.getElementById('seed-card-option');
      if (carte) plus.appendChild(carte);
    }
    if (blocBoite && isKit) {
      blocBoite.style.display = 'none';
      var inclus = document.createElement('p');
      inclus.className = 'jp-plus__inclus';
      inclus.textContent = TEXTE_BOITE_INCLUSE;
      blocBoite.parentNode.insertBefore(inclus, blocBoite);
    }
    var vignetteBoite = document.getElementById('jp-boite-thumb');
    if (vignetteBoite) vignetteBoite.addEventListener('click', function () { zoomer(vignetteBoite.dataset.grande || vignetteBoite.src); });
    construireExtras();

    /* 4. Délai au-dessus du bouton, pictos en dessous */
    var delai = document.getElementById('jp-delai');
    var pictos = document.getElementById('jp-pictos');
    var boutonsPaiement = form.querySelector('.shopify-payment-button');
    if (boutonPanier) {
      if (delai) { boutonPanier.parentNode.insertBefore(delai, boutonPanier); delai.hidden = false; }
      if (pictos) {
        var apres = boutonsPaiement || boutonPanier;
        apres.parentNode.insertBefore(pictos, apres.nextSibling);
        pictos.hidden = false;
      }
    }
    /* Date de livraison estimée (Baymard : une date rassure plus qu'un délai) :
       jours ouvrés, sans week-ends, jours fériés ni fermetures de l'atelier */
    (function () {
      var zd = document.getElementById('jp-delai-date');
      if (!zd || JP_LIQ.livDate === false) return;
      var mini = +JP_LIQ.livMin || 0, maxi = +JP_LIQ.livMax || 0;
      if (!mini || !maxi || maxi < mini) return;
      var ferme = String(JP_LIQ.fermetures || '').split(/\n/).map(function (l) {
        var m = l.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})\s*-\s*(\d{1,2})\/(\d{1,2})\/(\d{4})/); if (!m) return null;
        return [new Date(+m[3], +m[2] - 1, +m[1], 0, 0), new Date(+m[6], +m[5] - 1, +m[4], 23, 59)];
      }).filter(Boolean);
      function paques(y) {
        var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
        var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
        return new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1, 12);
      }
      var cache = {};
      function feries(y) {
        if (cache[y]) return cache[y];
        var f = {}; ['1-1', '1-5', '8-5', '14-7', '15-8', '1-11', '11-11', '25-12'].forEach(function (x) { f[x] = 1; });
        var p = paques(y); [1, 39, 50].forEach(function (n) { var d = new Date(p); d.setDate(d.getDate() + n); f[d.getDate() + '-' + (d.getMonth() + 1)] = 1; });
        return (cache[y] = f);
      }
      function ouvre(d) { if (d.getDay() === 0 || d.getDay() === 6 || feries(d.getFullYear())[d.getDate() + '-' + (d.getMonth() + 1)]) return false; return !ferme.some(function (x) { return d >= x[0] && d <= x[1]; }); }
      function plus(n) { var d = new Date(); d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12); var garde = 0; while (n > 0 && garde++ < 400) { d.setDate(d.getDate() + 1); if (ouvre(d)) n--; } return d; }
      var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
      var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      var d1 = plus(mini), d2 = plus(maxi);
      var t1 = JOURS[d1.getDay()] + ' ' + (d1.getDate() === 1 ? '1er' : d1.getDate()) + (d1.getMonth() !== d2.getMonth() ? ' ' + MOIS[d1.getMonth()] : '');
      var t2 = JOURS[d2.getDay()] + ' ' + (d2.getDate() === 1 ? '1er' : d2.getDate()) + ' ' + MOIS[d2.getMonth()];
      /* Bas du configurateur : la date seule, sur deux lignes (le délai d'expédition n'apporte rien de plus) */
      zd.textContent = '';
      zd.appendChild(document.createTextNode('Commandé aujourd\'hui, livré en France'));
      zd.appendChild(document.createElement('br'));
      zd.appendChild(document.createTextNode('entre le ' + t1 + ' et le ' + t2 + '.'));
      zd.hidden = false;
      var pDelai = zd.parentNode && zd.parentNode.querySelector('p:not(.jp-delai__date):not(.jp-delai__info)');
      if (pDelai) pDelai.hidden = true;
      /* Haut du configurateur, sous le prix : la date remplace « habituellement expédié sous… » */
      var zh = document.getElementById('jp-delai-haut');
      if (zh) {
        var info = zh.querySelector('span');
        zh.textContent = '';
        zh.appendChild(document.createTextNode('Commandé aujourd\'hui, livré en France entre le ' + t1 + ' et le ' + t2 + '.'));
        if (info) { zh.appendChild(document.createElement('br')); zh.appendChild(info); }
      }
    })();

    var delaiHaut = document.getElementById('jp-delai-haut');
    var zoneVariantes = form.querySelector('.ProductForm__Variants');
    if (delaiHaut && zoneVariantes) { zoneVariantes.parentNode.insertBefore(delaiHaut, zoneVariantes); delaiHaut.hidden = false; }

    /* Conseils de taille dans les boutons + note sous les coupelles */
    function noteSous(pos, lignes, avant) {
      var r = radiosPosition(pos)[0];
      var ulOpt = r ? r.closest('ul') : null;
      if (!ulOpt || !lignes.length) return ulOpt;
      var note = document.createElement('p');
      note.className = 'jp-option-note' + (avant ? '' : ' jp-option-note--apres');
      lignes.forEach(function (l, i) {
        if (i) note.appendChild(document.createElement('br'));
        note.appendChild(document.createTextNode(l));
      });
      ulOpt.parentNode.insertBefore(note, avant ? ulOpt : ulOpt.nextSibling);
      return ulOpt;
    }
    var posTaille = optIdx('taille') + 1;
    if (posTaille > 0) {
      var avecConseil = false;
      radiosPosition(posTaille).forEach(function (r) {
        var m = r.value.match(/\d+/);
        var c = m ? CONSEILS_TAILLE[m[0]] : null;
        var lab = r.nextElementSibling;
        if (!c || !lab) return;
        if (lab.firstChild && lab.firstChild.nodeType === 3) lab.firstChild.textContent = lab.firstChild.textContent.trim().replace(/\s*\(/, '\n(');
        c.forEach(function (l) {
          var sp = document.createElement('span');
          sp.className = 'jp-conseil';
          sp.textContent = l;
          lab.appendChild(sp);
        });
        avecConseil = true;
      });
      if (avecConseil) {
        var ulTaille = noteSous(posTaille, INTRO_TAILLE, true);
        if (ulTaille) ulTaille.classList.add('jp-tailles');
      }
    }
    function lienPhoto(pos, texteLien, src) {
      var r = radiosPosition(pos)[0];
      var ulOpt = r ? r.closest('ul') : null;
      if (!ulOpt || !src) return;
      var dernier = ulOpt;
      while (dernier.nextElementSibling && dernier.nextElementSibling.classList.contains('jp-option-note')) dernier = dernier.nextElementSibling;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jp-lien-photo';
      b.textContent = texteLien;
      b.addEventListener('click', function () { zoomer(src); });
      dernier.parentNode.insertBefore(b, dernier.nextSibling);
    }
    if (posTaille > 0) lienPhoto(posTaille, LIEN_PHOTO_TAILLES, cfg.photoTailles);
    var posCoupelle = optIdx('coupelle') + 1;
    if (posCoupelle > 0 && NOTE_COUPELLE) noteSous(posCoupelle, [NOTE_COUPELLE], true);
    if (posCoupelle > 0) lienPhoto(posCoupelle, LIEN_PHOTO_COUPELLES, cfg.photoCoupelles);
    /* Prix affiché sous chaque taille et chaque coupelle (aide à choisir sans tout essayer) */
    function majPrixOptions() {
      var sel = selection();
      function candidats(fixes) {
        return cfg.variants.filter(function (v) {
          for (var p in fixes) { if (fixes[p] !== undefined && v['option' + p] !== fixes[p]) return false; }
          return true;
        });
      }
      function mini(l) { return l.length ? Math.min.apply(null, l.map(function (v) { return v.price; })) : null; }
      function etiquette(r, txt) {
        var lab = r.nextElementSibling; if (!lab) return;
        var sp = lab.querySelector('.jp-prix-opt');
        if (!txt) { if (sp) sp.remove(); return; }
        if (!sp) { sp = document.createElement('span'); sp.className = 'jp-prix-opt'; lab.appendChild(sp); }
        sp.textContent = txt;
      }
      var autres = {};
      for (var p = 1; p <= cfg.options.length; p++) { if (p !== posTaille && p !== posCoupelle) autres[p] = sel[p]; }
      var modeleChoisi = Object.keys(autres).every(function (k) { return autres[k] !== undefined; });
      var sansVal = null;
      if (posCoupelle > 0) radiosPosition(posCoupelle).forEach(function (r) { if (/sans/i.test(r.value)) sansVal = r.value; });
      if (posTaille > 0) radiosPosition(posTaille).forEach(function (r) {
        var f = {}; for (var k in autres) f[k] = autres[k]; f[posTaille] = r.value;
        if (posCoupelle > 0 && sansVal) f[posCoupelle] = sansVal;
        var m = mini(candidats(f));
        etiquette(r, m === null ? '' : (modeleChoisi ? '' : 'dès ') + formater(m));
      });
      if (posCoupelle > 0) {
        var base = {}; for (var k2 in autres) base[k2] = autres[k2];
        if (posTaille > 0) base[posTaille] = sel[posTaille];
        var mSans = sansVal ? mini(candidats(Object.assign({}, base, (function () { var o = {}; o[posCoupelle] = sansVal; return o; })()))) : null;
        radiosPosition(posCoupelle).forEach(function (r) {
          if (r.value === sansVal || mSans === null) { etiquette(r, ''); return; }
          var o = {}; o[posCoupelle] = r.value;
          var mAvec = mini(candidats(Object.assign({}, base, o)));
          var d = mAvec === null ? null : mAvec - mSans;
          var exact = modeleChoisi && (posTaille < 1 || sel[posTaille] !== undefined);
          etiquette(r, d && d > 0 ? (exact ? '' : 'dès ') + '+' + formater(d) : '');
        });
      }
    }
    /* Joli pot doré (édition limitée Noël) : rappel de la date limite avec le nombre de jours restants, sous les modèles */
    var DORE_FIN = new Date(2026, 11, 26, 23, 59, 59);
    function majDore() {
      var r0 = radiosPosition(1)[0], ulM = r0 ? r0.closest('ul') : null;
      if (!ulM) return;
      var note = document.getElementById('jp-dore-note');
      var on = /dor[ée]/i.test(selection()[1] || '');
      var j = Math.ceil((DORE_FIN - new Date()) / 86400000);
      if (!on || j < 1) { if (note) note.hidden = true; return; }
      if (!note) {
        note = document.createElement('p'); note.id = 'jp-dore-note';
        note.style.cssText = 'margin:10px 0 0;padding:10px 14px;border-radius:var(--jp-arrondi,8px);background:#f6ecd6;color:#6b4e12;font-size:14px;line-height:1.45';
        ulM.parentNode.insertBefore(note, ulM.nextSibling);
      }
      note.hidden = false;
      note.innerHTML = '<strong>Édition limitée</strong>, disponible jusqu\'au 26 décembre : ' + (j === 1 ? 'dernier jour pour le commander !' : 'plus que <strong>' + j + ' jours</strong> pour l\'offrir.');
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { setTimeout(majPrixOptions, 0); setTimeout(majDore, 0); }); });
    majPrixOptions();
    majDore();
    setTimeout(majDore, 400);
    if (texte && PLACEHOLDER_MESSAGE) texte.placeholder = PLACEHOLDER_MESSAGE;

    /* Éléments du parcours progressif */
    blocsOptions = Array.prototype.slice.call(form.querySelectorAll('.ProductForm__Option')).filter(function (b) {
      return b.querySelector('.SizeSwatch__Radio, .ColorSwatch__Radio');
    });
    if (isPot && modeleDejaChoisi && blocsOptions[0]) blocsOptions[0].dataset.jpFait = '1';
    if (modeEdit) blocsOptions.forEach(function (b) { b.dataset.jpFait = '1'; });
    if (plus) finEls.push(plus);
    var qteSel = form.querySelector('.ProductForm__QuantitySelector');
    if (qteSel) {
      finEls.push(qteSel);
      var noteQte = document.createElement('p');
      noteQte.textContent = "La quantité s'applique au pot et à ses options à l'identique. Pour des messages différents, ajoutez chaque pot séparément.";
      noteQte.style.cssText = 'font-size:.8em;opacity:.75;margin:6px 0 0;';
      qteSel.parentNode.insertBefore(noteQte, qteSel.nextSibling);
      finEls.push(noteQte);
      var labQte = qteSel.previousElementSibling;
      if (labQte && labQte.classList.contains('ProductForm__Label')) finEls.push(labQte);
    }
    if (delai) finEls.push(delai);
    if (pictos) finEls.push(pictos);

    /* Un clic sur une option valide l'étape (même sur l'option déjà présélectionnée) */
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.jp-mloupe')) return;
      var lab = e.target.closest ? e.target.closest('.SizeSwatch, .ColorSwatch') : null;
      if (!lab) return;
      poserVerrou();
      var b = lab.closest('.ProductForm__Option');
      if (!b || blocsOptions.indexOf(b) < 0) return;
      var radio = lab.getAttribute('for') ? document.getElementById(lab.getAttribute('for')) : null;
      var dejaCoche = !!(radio && radio.checked);
      b.dataset.jpFait = '1';
      setTimeout(majEtapes, 0);
      majPrixPlusTard();
      if (isPot && dejaCoche && radio.dataset.optionPosition === '1') continuer();
    }, true);

    /* Mise à jour du prix quand on coche une option ou change la quantité */
    form.addEventListener('change', majPrixPlusTard);
    form.addEventListener('input', majPrixPlusTard);
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.QuantitySelector__Button')) majPrixPlusTard();
    });

    /* 5. Compteur de caractères */
    if (texte && TITRE_CHAMP) {
      var titreChamp = document.createElement('p');
      titreChamp.className = 'jp-titre-champ';
      titreChamp.textContent = TITRE_CHAMP;
      texte.parentNode.insertBefore(titreChamp, texte);
    }
    if (texte) {
      compteur = document.createElement('p');
      compteur.className = 'jp-compteur';
      texte.parentNode.insertBefore(compteur, texte.nextSibling);
      /* Options gratuites (cœur, envoi direct) rangées sous le message */
      var optionsMsg = document.createElement('div');
      optionsMsg.className = 'jp-options-msg';
      ['jp-sans-coeur', 'jp-cadeau'].forEach(function (id) {
        var c = document.getElementById(id);
        var l = c ? (c.closest('label') || document.querySelector('label[for="' + id + '"]')) : null;
        if (l) optionsMsg.appendChild(l);
      });
      if (optionsMsg.children.length) compteur.parentNode.insertBefore(optionsMsg, compteur.nextSibling);
      texte.addEventListener('input', function () { majLimite(); majEtapes(); });
    }

    /* Compteur de caractères de la carte à planter */
    var texteCarteEl = document.getElementById('seed-text');
    if (texteCarteEl && LIMITE_CARTE) {
      texteCarteEl.maxLength = LIMITE_CARTE;
      var compteurCarte = document.createElement('p');
      compteurCarte.className = 'jp-compteur';
      texteCarteEl.parentNode.insertBefore(compteurCarte, texteCarteEl.nextSibling);
      var majCompteurCarte = function () {
        compteurCarte.textContent = texteCarteEl.value.length + ' / ' + LIMITE_CARTE + ' caractères';
      };
      texteCarteEl.addEventListener('input', majCompteurCarte);
      majCompteurCarte();
    }
    var apercuCarte = (texteCarteEl && cfg.apercuCarte && cfg.apercuCarte.actif) ? creerApercuCarte(texteCarteEl, cfg.apercuCarte) : null;
    var apercuPot = (texte && (isPot || isKit || cfg.message || cfg.occasion) && cfg.apercuPot && cfg.apercuPot.actif) ? creerApercuPot(cfg.apercuPot) : null;

    /* 6. Idées de messages (liste déroulante des occasions) */
    var idees = document.getElementById('jp-idees');
    var source = OCCASIONS;
    var occs = source.filter(function (o) { return o.nom && o.messages; });
    if (idees && texte && occs.length) {
      if (labTexte) labTexte.parentNode.insertBefore(idees, labTexte.nextSibling);
      occs.sort(function (a, b) { return (a.ordre || 99) - (b.ordre || 99); });
      var zoneChoix = idees.querySelector('.jp-idees__onglets');
      var liste = idees.querySelector('.jp-idees__liste');
      var choix = document.createElement('select');
      choix.className = 'jp-idees__select';
      choix.setAttribute('aria-label', 'Choisissez un thème');
      occs.forEach(function (o, i) {
        var op = document.createElement('option');
        op.value = String(i);
        op.textContent = o.nom;
        choix.appendChild(op);
      });
      zoneChoix.appendChild(choix);

      var afficher = function (i) {
        choix.value = String(i);
        liste.innerHTML = '';
        occs[i].messages.split(/\r?\n/).map(function (m) { return m.trim(); }).filter(Boolean).forEach(function (m) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jp-idees__msg';
          b.textContent = m;
          b.addEventListener('click', function () {
            texte.value = m;
            texte.dispatchEvent(new Event('input', { bubbles: true }));
            liste.querySelectorAll('.is-choisi').forEach(function (x) { x.classList.remove('is-choisi'); });
            b.classList.add('is-choisi');
            var debut = m.indexOf('[');
            var fin = m.indexOf(']', debut);
            if (debut > -1 && fin > debut) {
              texte.focus({ preventScroll: true });
              texte.setSelectionRange(debut, fin + 1);
            }
          });
          liste.appendChild(b);
        });
        majLimite();
      };

      choix.addEventListener('change', function () { afficher(parseInt(choix.value, 10)); });
      idees.hidden = false;

      var occUrl = (new URLSearchParams(window.location.search).get('occasion') || '').toLowerCase();
      var depart = 0;
      if (occUrl) {
        occs.forEach(function (o, i) { if (o.nom.toLowerCase() === occUrl) depart = i; });
      }
      afficher(depart);
    }


    /* Aperçu en direct du pot : message manuscrit en légère courbe, cœur et signature facultative.
       Ordinateur : en tête de la galerie (reste visible en défilant). Mobile : juste sous le message. */
    function creerApercuPot(ap) {
      /* Police manuscrite chargée seulement quand la cliente commence son message (page plus rapide à l'ouverture) */
      var policeOk = false;
      function chargerPolice() {
        if (policeOk) return; policeOk = true;
        if (!document.getElementById('jp-ap-police')) {
          var lk = document.createElement('style'); lk.id = 'jp-ap-police';
          lk.textContent = '@font-face{font-family:"Sacramento";src:url(' + POLICES_JP['Sacramento'] + ') format("woff2");font-display:swap}'; document.head.appendChild(lk);
        }
        if (document.fonts && document.fonts.load) document.fonts.load('20px "Sacramento"').then(function () { ctx = null; dessiner(); }, function () {});
      }
      var POL = "Sacramento, 'Brush Script MT', cursive", NS = 0, ctx = null;
      function largeur(t) {
        if (!ctx) { try { ctx = document.createElement('canvas').getContext('2d'); } catch (e) {} }
        if (!ctx) return t.length * 0.42;
        ctx.font = '10px ' + POL; return ctx.measureText(t).width / 10;
      }
      /* Champ signature, toujours dans le formulaire pour partir avec le pot */
      var zoneSig = document.createElement('div'); zoneSig.className = 'jp-ap-sigzone';
      zoneSig.innerHTML = '<label class="jp-ap__lab" for="jp-ap-sig">' + ap.sigLabel + (ap.sigAide ? ' <span>(' + ap.sigAide + ')</span>' : '') + '</label>'
        + '<input type="text" id="jp-ap-sig" name="properties[Signature sur le pot]" autocomplete="off">';
      var sigEl = zoneSig.querySelector('input'); sigEl.maxLength = ap.sigMax || 20; sigEl.placeholder = ap.sigPh || '';
      var apresMsg = form.querySelector('.jp-options-msg') || compteur || texte;
      apresMsg.parentNode.insertBefore(zoneSig, apresMsg.nextSibling);
      /* Bloc d'aperçu */
      var bloc = document.createElement('div'); bloc.className = 'jp-ap'; bloc.hidden = true;
      bloc.innerHTML = '<div class="jp-ap__scene"><span class="jp-ap__tag">' + ap.titre + '</span><div class="jp-ap__svg"></div><p class="jp-ap__legende"></p></div>'
        + (ap.exemple ? '<button type="button" class="jp-ap__ex"><img src="' + ap.exemple.petite + '" alt=""><span><b>' + ap.exempleTxt + '</b>' + (ap.mention || '') + '</span></button>'
          : (ap.mention ? '<p class="jp-ap__mention">' + ap.mention + '</p>' : ''));
      var svgEl = bloc.querySelector('.jp-ap__svg'), leg = bloc.querySelector('.jp-ap__legende');
      var ex = bloc.querySelector('.jp-ap__ex');
      if (ex) ex.addEventListener('click', function () {
        var f = document.createElement('div'); f.className = 'jp-ap-fen';
        f.innerHTML = '<div><img src="' + ap.exemple.grande + '" alt=""><button type="button" aria-label="Fermer">×</button></div>';
        f.addEventListener('click', function (e) { if (e.target === f || e.target.tagName === 'BUTTON') f.remove(); });
        document.body.appendChild(f);
      });
      var mq = window.matchMedia('(min-width: 1008px)');
      function placer() {
        var gal = document.querySelector('product-gallery');
        if (false && mq.matches && gal) { if (bloc.parentNode !== gal) gal.insertBefore(bloc, gal.firstChild); bloc.classList.add('is-galerie'); }
        else { if (bloc.previousSibling !== zoneSig) zoneSig.parentNode.insertBefore(bloc, zoneSig.nextSibling); bloc.classList.remove('is-galerie'); }
      }
      if (mq.addEventListener) mq.addEventListener('change', placer); else if (mq.addListener) mq.addListener(placer);
      function valeur(motCle) { var i = optIdx(motCle); return i < 0 ? '' : (selection()[String(i + 1)] || ''); }
      /* Formes des pots, reprises de l'aperçu entreprise (viewBox 200 x 200) :
         pot habituel (blanc ou terra, 6 à 13 cm), bougie (pot blanc et sa cire), Flora (petit pot terra et sa fleur au crochet) */
      var FORMES = {
        pot: { haut: 80, bas: 154, top: 76, h: 88, g0: 56, d0: 144, pente: 11, marge: 12 },
        flora: { haut: 101, bas: 152, top: 96, h: 62, g0: 72, d0: 128, pente: 7, marge: 5 }
      };
      var geo = FORMES.pot;
      function bords(y) { var dx = (y - geo.top) * geo.pente / geo.h; return { g: geo.g0 + dx + geo.marge, d: geo.d0 - dx - geo.marge }; }
      function formeDe(modele) {
        if (isKit || !modele) return 'blanc';
        if (/flora/i.test(modele)) return 'flora';
        if (/bougie/i.test(modele)) return 'bougie';
        if (/terra/i.test(modele)) return 'terra';
        if (/dor[ée]/i.test(modele)) return 'dore';
        return 'blanc';
      }
      /* Petit cœur : moitié de l'ancien, avec un vrai espace sous le texte */
      var COEUR_D = 'c-1.2-1.2-6-4.2-6-7.2 0-1.9 1.2-3.1 3.1-3.1 1.2 0 2.2.7 2.9 1.9.7-1.2 1.7-1.9 2.9-1.9 1.9 0 3.1 1.2 3.1 3.1 0 3-4.8 6-6 7.2z';
      var COEUR_ECH = 0.5, COEUR_H = 10.3 * COEUR_ECH;
      function coupes(m, k) {
        var res = [];
        (function r(d, k2, acc) {
          if (k2 === 1) { res.push(acc.concat([m.slice(d).join(' ')])); return; }
          for (var i = d + 1; i <= m.length - k2 + 1; i++) r(i, k2 - 1, acc.concat([m.slice(d, i).join(' ')]));
        })(0, k, []);
        return res;
      }
      /* Coupure équilibrée : le moins de lignes possible (3 au maximum), lignes de longueurs proches, pas de mot seul en dernière ligne si on peut l'éviter */
      var LIES = ['pour','et','de','du','des','à','au','aux','le','la','les','un','une','en','que','qui','mon','ma','mes','ton','ta','tes','son','sa','ses','avec','sans','sur','par','dans','ou','mais','nos','vos','notre','votre','ce','cette'];
      function equilibrer(ligne, larg, fs, forcer) {
        var m = ligne.split(/\s+/).filter(Boolean); if (!m.length) return [];
        var secours = null, secoursMax = Infinity;
        for (var k = 1; k <= Math.min(3, m.length); k++) {
          var choix = null, cout = Infinity;
          coupes(m, k).forEach(function (l) {
            var ws = l.map(function (x) { return largeur(x) * fs; }), mx = Math.max.apply(null, ws);
            if (mx < secoursMax) { secoursMax = mx; secours = l; }
            if (mx > larg) return;
            var moy = ws.reduce(function (a, b) { return a + b; }, 0) / k;
            var c = mx + ws.reduce(function (a, b) { return a + Math.abs(b - moy); }, 0) * 0.3;
            if (k > 1 && m.length > k && l[k - 1].indexOf(' ') < 0) c += larg;
            /* Coupure naturelle : on évite de finir une ligne sur un petit mot de liaison (pour, et, de, à…) */
            for (var z = 0; z < k - 1; z++) { var dern = l[z].split(' ').pop().toLowerCase(); if (LIES.indexOf(dern) > -1 || /['’]$/.test(dern)) c += larg * 0.6; }
            if (c < cout) { cout = c; choix = l; }
          });
          if (choix) return choix;
        }
        return forcer ? secours : null;
      }
      function couper(ligne, larg, fs) {
        var mots = ligne.split(/\s+/).filter(Boolean), res = [], c = '';
        mots.forEach(function (w) { var t = c ? c + ' ' + w : w; if (c && largeur(t) * fs > larg) { res.push(c); c = w; } else c = t; });
        if (c) res.push(c); return res;
      }
      function dessiner() {
        var v = texte.value.replace(/\r/g, '').trim(), sg = sigEl.value.trim();
        if (v) chargerPolice();
        var modele = valeur('mod'), forme = formeDe(modele);
        bloc.hidden = !v;
        if (bloc.hidden) return;
        placer();
        geo = forme === 'flora' ? FORMES.flora : FORMES.pot;
        var surTerra = forme === 'terra' || forme === 'flora', encre = surTerra ? '#fff' : '#1d1a17';
        var taille = (valeur('taille').match(/\d+/) || [''])[0];
        var coupelle = isKit || (forme !== 'flora' && forme !== 'bougie' && /avec/i.test(valeur('coupelle')));
        var coeur = !(document.getElementById('jp-sans-coeur') || {}).checked;
        var brut = v.split('\n').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 6);
        /* Plus grande taille qui tient : largeur du pot à chaque hauteur, hauteur totale disponible */
        var fs = ({ '5': 11, '6': 13, '8': 14, '11': 15, '13': 16 })[taille] || (forme === 'flora' ? 11 : 15), lignes = [], lh, haut = geo.haut, bas = geo.bas;
        var ecart = 0; var FSMIN = (forme === 'flora' ? 6 : 8);
        for (; fs >= (forme === 'flora' ? 6 : 8); fs -= 0.5) {
          lh = fs * 0.98;
          var ok = true; lignes = [];
          var yMil = (haut + bas) / 2, largeMoy = bords(yMil).d - bords(yMil).g;
          brut.forEach(function (b) { var lb = equilibrer(b, largeMoy, fs, fs - 0.5 < FSMIN); if (!lb) ok = false; else lb.forEach(function (x) { lignes.push(x); }); });
          if (!ok) continue;
          ecart = Math.max(4, fs * 0.45);
          var sigH = sg ? Math.max(6, fs * 0.5) + 4 : 0, coeurH = coeur ? ecart + COEUR_H + 2 : 0;
          var total = lignes.length * lh + coeurH + sigH;
          if (total > bas - haut) continue;
          var y = haut + (bas - haut - total) / 2 + lh * 0.72;
          for (var k = 0; k < lignes.length; k++) { var bd = bords(y + k * lh); if (largeur(lignes[k]) * fs > bd.d - bd.g) { ok = false; break; } }
          if (ok) break;
        }
        var y0 = haut + (bas - haut - total) / 2 + lh * 0.72, id = 'jpap' + (++NS), s = '';
        s += '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + v.replace(/"/g, '&quot;') + '"><defs>';
        lignes.forEach(function (x, k) { var y = y0 + k * lh, bd = bords(y); s += '<path id="' + id + k + '" d="M' + (bd.g - 6).toFixed(1) + ' ' + y.toFixed(1) + ' Q100 ' + (y + 4).toFixed(1) + ' ' + (bd.d + 6).toFixed(1) + ' ' + y.toFixed(1) + '"/>'; });
        s += '</defs>';
        if (coupelle) s += forme === 'dore' ? '<ellipse cx="100" cy="172" rx="66" ry="9" fill="#b8913f"/><rect x="36" y="161" width="128" height="10" rx="3" fill="#cfa84f"/>' : '<ellipse cx="100" cy="172" rx="66" ry="9" fill="#b9644f"/><rect x="36" y="161" width="128" height="10" rx="3" fill="#ad523f"/>';
        if (forme === 'flora') {
          s += '<path d="M72 96h56l-7 62H79z" fill="#c4704f"/><rect x="66" y="86" width="68" height="13" rx="3" fill="#b35f40"/>';
          s += '<path d="M100 86c-1-14-1-24 0-30" stroke="#647d69" stroke-width="3" fill="none"/><path d="M100 56c-3-6-14-8-14 1 0 7 10 11 14 16 4-5 14-9 14-16 0-9-11-7-14-1z" fill="#d23a3a"/>';
        } else if (forme === 'terra') {
          s += '<path d="M56 76h88l-11 88H67z" fill="#c4704f"/><path d="M56 76h88l-1 7H57z" fill="#000" opacity=".06"/><rect x="47" y="58" width="106" height="20" rx="3" fill="#b35f40"/>';
        } else {
          s += '<path d="M56 76h88l-11 88H67z" fill="#fff" stroke="#e6ddd2"/><path d="M56 76h88l-1 7H57z" fill="#000" opacity=".05"/><rect x="47" y="58" width="106" height="20" rx="3" fill="' + (forme === 'dore' ? '#cfa84f' : '#ad513f') + '"/>' + (forme === 'dore' ? '<rect x="47" y="60" width="106" height="4" rx="2" fill="#fff" opacity=".35"/>' : '');
          if (forme === 'bougie') s += '<ellipse cx="100" cy="60" rx="47" ry="5" fill="#f6efe2"/><path d="M100 59v-12" stroke="#2a211c" stroke-width="2"/><path d="M100 46c-6-8 0-16 0-21 0 5 6 13 0 21z" fill="#f2c94c"/>';
        }
        lignes.forEach(function (x, k) {
          var t = x.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
          s += '<text font-family="' + POL.replace(/"/g, '') + '" font-size="' + fs.toFixed(1) + '" font-weight="700" fill="' + encre + '" text-anchor="middle"><textPath href="#' + id + k + '" startOffset="50%">' + t + '</textPath></text>';
        });
        var yb = y0 + (lignes.length - 1) * lh + fs * 0.32;
        if (coeur) { yb += ecart + COEUR_H; s += '<path transform="translate(100 ' + yb.toFixed(1) + ') scale(' + COEUR_ECH + ') translate(-100 0)" d="M100 0' + COEUR_D + '" fill="' + (surTerra ? '#fff' : (forme === 'dore' ? '#c9a13f' : '#c8102e')) + '"/>'; }
        if (sg) { var fsS = Math.min(fs * 0.62, 13); yb += fsS + 2; s += '<text x="100" y="' + yb.toFixed(1) + '" font-family="' + POL.replace(/"/g, '') + '" font-size="' + fsS.toFixed(1) + '" fill="' + encre + '" text-anchor="middle">' + sg.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</text>'; }
        svgEl.innerHTML = s + '</svg>';
        leg.textContent = [modele || '', taille ? '⌀ ' + taille + ' cm' : '', coupelle && !isKit ? 'avec coupelle' : ''].filter(Boolean).join(' · ');
      }
      var att = null;
      function plusTard() { clearTimeout(att); att = setTimeout(dessiner, 60); }
      texte.addEventListener('input', plusTard); sigEl.addEventListener('input', plusTard);
      form.addEventListener('change', plusTard);
      texte.addEventListener('focus', chargerPolice);
      setTimeout(dessiner, 300);
      return { dessiner: dessiner, sig: sigEl };
    }

    /* Aperçu en direct de la carte à planter : apparaît dès que le client commence à écrire */
    function creerApercuCarte(champ, ca) {
      /* Polices de la carte chargées seulement quand la cliente écrit sur la carte */
      var policesOk = false;
      function chargerPolices() {
      if (policesOk) return; policesOk = true;
      if (!document.getElementById('jp-ca-polices')) {
        var lien = document.createElement('style');
        lien.id = 'jp-ca-polices';
        lien.textContent = STYLES_CARTE.filter(function (st) { return POLICES_JP[st.police]; })
          .map(function (st) { return '@font-face{font-family:"' + st.police + '";src:url(' + POLICES_JP[st.police] + ') format("woff2");font-display:swap}'; }).join('');
        document.head.appendChild(lien);
        var ff = document.createElement('style');
        ff.textContent = '@font-face{font-family:"Orwell";src:url(' + POLICE_ORWELL_URL + ') format("woff2");font-display:swap}';
        document.head.appendChild(ff);
      }
      if (document.fonts && document.fonts.load) {
        STYLES_CARTE.forEach(function (st) { document.fonts.load('20px "' + st.police + '"').then(function () { maj(); }, function () {}); });
      }
      }
      var COEUR = '<svg viewBox="0 0 100 90" aria-hidden="true"><path fill="#8c3f34" d="M50 88C47 85 6 58 4 30 2 13 14 2 28 2c11 0 18 7 22 15 4-8 11-15 22-15 14 0 26 11 24 28-2 28-43 55-46 58z"/></svg>';
      var styleChoisi = STYLES_CARTE[0];

      /* Une carte (texte, cœur, signature) : à plat dans la page, ou posée sur la photo dans la fenêtre */
      function fabriquerCarte(avecPapier) {
        var el = document.createElement('div');
        el.className = 'jp-ca__carte';
        el.innerHTML = (avecPapier ? '<canvas aria-hidden="true"></canvas>' : '') +
          '<div class="jp-ca__zone"><div class="jp-ca__texte"></div><span class="jp-ca__coeur">' + COEUR + '</span><div class="jp-ca__signature"></div></div>' +
          (avecPapier && ca.logo ? '<img class="jp-ca__logo" alt="Joli Pot" src="' + ca.logo + '">' : '');
        return {
          el: el, cv: el.querySelector('canvas'), zone: el.querySelector('.jp-ca__zone'),
          txt: el.querySelector('.jp-ca__texte'), coeur: el.querySelector('.jp-ca__coeur'), sig: el.querySelector('.jp-ca__signature')
        };
      }
      /* Petits points du papier ensemencé, toujours le même dessin */
      function mouchetis(c) {
        if (!c.cv) return;
        var w = c.el.offsetWidth, h = c.el.offsetHeight, d = window.devicePixelRatio || 1;
        if (!w) return;
        c.cv.width = w * d; c.cv.height = h * d;
        var g = c.cv.getContext('2d'); g.scale(d, d); g.clearRect(0, 0, w, h);
        var s = 7; function rnd() { s = (s * 16807) % 2147483647; return s / 2147483647; }
        for (var i = 0; i < 90; i++) {
          var x = rnd() * w, y = rnd() * h, t = 0.5 + rnd() * 1.6;
          g.fillStyle = 'rgba(120,128,110,' + (0.25 + rnd() * 0.45) + ')';
          g.beginPath(); g.arc(x, y, t, 0, Math.PI * 2); g.fill();
        }
      }
      /* Plus grande taille de texte qui tient dans la zone, signature toujours plus petite que le message */
      function remplir(c) {
        var W = c.el.offsetWidth;
        if (!W) return;
        var v = champ.value.trim();
        c.txt.textContent = v || CA_VIDE;
        c.txt.classList.toggle('is-vide', !v);
        c.sig.textContent = sig.value.trim();
        var police = '"' + styleChoisi.police + '", cursive';
        c.txt.style.fontFamily = police;
        c.sig.style.fontFamily = police;
        var sigMax = W * 0.045;
        c.sig.style.fontSize = sigMax + 'px';
        var zh = c.zone.clientHeight, zw = c.zone.clientWidth;
        var h = zh - c.coeur.offsetHeight - c.sig.offsetHeight - zh * (c.sig.textContent ? 0.24 : 0.12);
        var lo = 6, hi = Math.min(W * styleChoisi.plafond / 100, h), best = lo;
        for (var k = 0; k < 12; k++) {
          var mid = (lo + hi) / 2;
          c.txt.style.fontSize = mid + 'px';
          if (c.txt.scrollHeight <= h && c.txt.scrollWidth <= zw) { best = mid; lo = mid; } else { hi = mid; }
        }
        c.txt.style.fontSize = best + 'px';
        c.sig.style.fontSize = Math.min(sigMax, best * 0.85) + 'px';
      }

      /* Bloc dans la page : aperçu, styles, signature, mention */
      var bloc = document.createElement('div');
      bloc.className = 'jp-ca';
      bloc.hidden = true;
      bloc.innerHTML =
        '<div class="jp-ca__scene"></div>' +
        (ca.photo ? '<button type="button" class="jp-ca__vue">' + CA_VOIR_PHOTO + '</button>' : '') +
        '<p class="jp-ca__mention"></p>' +
        '<p class="jp-ca__titre">' + CA_TITRE_STYLE + '</p>' +
        '<div class="jp-ca__styles" role="radiogroup"></div>' +
        '<label class="jp-ca__titre" for="jp-ca-sig">' + CA_TITRE_SIGNATURE + ' <span>(' + CA_AIDE_SIGNATURE + ')</span></label>' +
        '<input class="jp-ca__sig" id="jp-ca-sig" type="text" autocomplete="off">';
      var compteurC = champ.parentNode.querySelector('.jp-compteur');
      var ancre = compteurC || champ;
      if (CA_ASTUCE) {
        var astuce = document.createElement('p');
        astuce.className = 'jp-ca__astuce';
        astuce.textContent = CA_ASTUCE;
        ancre.parentNode.insertBefore(astuce, ancre.nextSibling);
        ancre = astuce;
      }
      ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
      var plate = fabriquerCarte(true);
      bloc.querySelector('.jp-ca__scene').appendChild(plate.el);
      var sig = bloc.querySelector('.jp-ca__sig');
      sig.maxLength = ca.limSignature || 30;
      sig.placeholder = CA_EXEMPLE_SIGNATURE;
      bloc.querySelector('.jp-ca__mention').textContent = ca.mention || '';
      var listeStyles = bloc.querySelector('.jp-ca__styles');
      STYLES_CARTE.forEach(function (st, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jp-ca__style' + (i === 0 ? ' is-choisi' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
        b.style.fontFamily = '"' + st.police + '", cursive';
        b.textContent = st.nom;
        b.addEventListener('click', function () {
          styleChoisi = st;
          listeStyles.querySelectorAll('.jp-ca__style').forEach(function (x) {
            x.classList.toggle('is-choisi', x === b);
            x.setAttribute('aria-checked', x === b ? 'true' : 'false');
          });
          maj();
        });
        listeStyles.appendChild(b);
      });

      /* Fenêtre « en situation » : la carte posée sur la photo, en suivant ses 4 coins */
      var coins = String(ca.coins || '').split('|').map(function (p) { return p.split(',').map(parseFloat); })
        .filter(function (p) { return p.length === 2 && !isNaN(p[0]) && !isNaN(p[1]); });
      function homographie(src, dst) {
        var A = [], B = [], i, c, r, k;
        for (i = 0; i < 4; i++) {
          var x = src[i][0], y = src[i][1], u = dst[i][0], v = dst[i][1];
          A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); B.push(u);
          A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); B.push(v);
        }
        for (c = 0; c < 8; c++) {
          var piv = c;
          for (r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[piv][c])) piv = r;
          var t = A[c]; A[c] = A[piv]; A[piv] = t; t = B[c]; B[c] = B[piv]; B[piv] = t;
          for (r = 0; r < 8; r++) {
            if (r === c) continue;
            var f = A[r][c] / A[c][c];
            for (k = c; k < 8; k++) A[r][k] -= f * A[c][k];
            B[r] -= f * B[c];
          }
        }
        var hh = B.map(function (b, j) { return b / A[j][j]; });
        return [hh[0], hh[3], 0, hh[6], hh[1], hh[4], 0, hh[7], 0, 0, 1, 0, hh[2], hh[5], 0, 1];
      }
      var fen = null, posee = null, photoFen = null;
      function placerSurPhoto() {
        if (!fen || fen.hidden || coins.length !== 4) return;
        remplir(posee);
        var pw = photoFen.clientWidth, ph = photoFen.clientHeight, W = posee.el.offsetWidth, H = posee.el.offsetHeight;
        if (!pw || !W) return;
        var dst = coins.map(function (p) { return [p[0] / 100 * pw, p[1] / 100 * ph]; });
        posee.el.style.transform = 'matrix3d(' + homographie([[0, 0], [W, 0], [W, H], [0, H]], dst).join(',') + ')';
      }
      function fermerFen() {
        if (!fen) return;
        fen.hidden = true;
        document.documentElement.classList.remove('jp-ca-ouvert');
      }
      function ouvrirFen() {
        if (!fen) {
          fen = document.createElement('div');
          fen.className = 'jp-ca-fen';
          fen.setAttribute('role', 'dialog');
          fen.setAttribute('aria-modal', 'true');
          fen.innerHTML = '<div class="jp-ca-fen__boite"><button type="button" class="jp-ca-fen__x" aria-label="Fermer">×</button>' +
            '<div class="jp-ca-fen__photo"><img alt="" src="' + ca.photo + '"></div></div>';
          photoFen = fen.querySelector('.jp-ca-fen__photo');
          posee = fabriquerCarte(false);
          photoFen.appendChild(posee.el);
          fen.addEventListener('click', function (e) { if (e.target === fen || e.target.closest('.jp-ca-fen__x')) fermerFen(); });
          document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermerFen(); });
          fen.querySelector('img').addEventListener('load', placerSurPhoto);
          window.addEventListener('resize', placerSurPhoto);
          document.body.appendChild(fen);
        }
        fen.hidden = false;
        document.documentElement.classList.add('jp-ca-ouvert');
        placerSurPhoto();
      }
      var btnVue = bloc.querySelector('.jp-ca__vue');
      if (btnVue) btnVue.addEventListener('click', ouvrirFen);

      function maj() {
        if (champ.value.trim()) chargerPolices();
        if (bloc.hidden && champ.value.trim()) {
          bloc.hidden = false;
          mouchetis(plate);
        }
        remplir(plate);
        placerSurPhoto();
      }
      champ.addEventListener('input', maj);
      sig.addEventListener('input', maj);
      /* Recalcule quand le bloc s'ouvre ou que la page change de largeur */
      var largeur = 0;
      function surTaille() {
        if (plate.el.offsetWidth === largeur) return;
        largeur = plate.el.offsetWidth;
        mouchetis(plate); remplir(plate);
      }
      if (window.ResizeObserver) new ResizeObserver(surTaille).observe(plate.el);
      else window.addEventListener('resize', surTaille);
      champ.addEventListener('focus', chargerPolices);
      maj();
      return {
        maj: maj,
        proprietes: function () {
          var p = {};
          /* Dans le panier et la commande : nom affiché + vraie police, ex. « Doux - Sacramento » */
          p[CA_PROP_STYLE] = styleChoisi.nom + ' - ' + styleChoisi.police;
          if (sig.value.trim()) p[CA_PROP_SIGNATURE] = sig.value.trim();
          return p;
        }
      };
    }

    /* 7. Mode modification : on reprend le pot tel qu'il est dans le panier */
    if (modeEdit) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ligne = cart.items.filter(function (it) { return it.key === modeEdit; })[0];
          if (!ligne) { modeEdit = null; return; }
          var p = ligne.properties || {};
          if (texte && p['Votre texte personnalisé']) texte.value = p['Votre texte personnalisé'];
          var sigPot = document.getElementById('jp-ap-sig');
          if (sigPot && p['Signature sur le pot']) sigPot.value = p['Signature sur le pot'];
          if (apercuPot) setTimeout(apercuPot.dessiner, 100);
          var caseCoeur = document.getElementById('jp-sans-coeur');
          if (caseCoeur) caseCoeur.checked = !!p['Sans cœur'];
          var caseCadeau = document.getElementById('jp-cadeau');
            if (caseCadeau) caseCadeau.checked = !!(p['Envoi direct au destinataire'] || p['Cadeau']);
          var champQte = form.querySelector('.QuantitySelector__CurrentQuantity');
          if (champQte) champQte.value = ligne.quantity;
          if (blocBoite && !isKit && cart.items.some(function (it) { return String(it.variant_id) === blocBoite.dataset.variantId; })) {
            blocBoite.style.display = 'none';
          }
          if (blocSusp) {
            var idsSusp = [];
            cfg.suspensions.forEach(function (sp) { sp.variantes.forEach(function (va) { idsSusp.push(String(va.id)); }); });
            if (cart.items.some(function (it) { return idsSusp.indexOf(String(it.variant_id)) > -1; })) {
              blocSusp.remove();
              blocSusp = null;
            }
          }
          (cfg.extras || []).forEach(function (x) {
            if (cart.items.some(function (it) { return String(it.variant_id) === String(x.id); }) && grilleExtras) {
              var c = grilleExtras.querySelector('[data-cle="x' + x.id + '"]');
              if (c) c.remove();
              extrasChoisis[x.id] = false;
            }
          });
          majExtras();
          majLimite();
          majEtapes();
          libelleEdit();
          majPrixPlusTard();
        })
        .catch(function () {});
    }

    /* Après l'ajout : type de panier choisi dans Paramètres du thème > Panier.
       Page : on ouvre la page panier. Tiroir : on prévient Prestige qui met à jour et ouvre son tiroir. */
    function jpApresAjout(btn) {
      var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var type = (window.themeVariables && themeVariables.settings && themeVariables.settings.cartType) || 'page';
      if (type === 'page') { window.location.href = racine + 'cart'; return; }
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      return Promise.all([
        fetch(racine + 'cart.js').then(function (r) { return r.json(); }),
        sections.length ? fetch(racine + '?sections=' + sections.join(',')).then(function (r) { return r.json(); }) : Promise.resolve({})
      ]).then(function (res) {
        var panier = res[0]; panier.sections = res[1];
        btn.disabled = false;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: panier } }));
      });
    }

    /* 8. Ajout au panier : limite de texte, carte, boîte et modification en un seul envoi */
    window.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.ProductForm__AddToCart') : null;
      if (!btn || !form.contains(btn)) return;

      var lim = limiteActuelle();
      if (texte && lim && texte.value.length > lim) {
        e.preventDefault();
        e.stopImmediatePropagation();
        texte.focus();
        return;
      }

      var caseCarte = document.getElementById('add-seed-card');
      var caseBoite = document.getElementById('jp-boite-check');
      var avecCarte = !!(caseCarte && caseCarte.checked);
      var avecBoite = !!(caseBoite && caseBoite.checked && blocBoite && blocBoite.style.display !== 'none');
      var avecSusp = !!(suspChoisie && blocSusp && blocSusp.style.display !== 'none');
      var extrasPanier = (cfg.extras || []).filter(function (x) { return extrasChoisis[x.id]; });
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!form.reportValidity()) return;

      var texteCarte = document.getElementById('seed-text');
      var boxCarte = document.getElementById('seed-card-message');
      if (boxCarte) boxCarte.querySelectorAll('.jp-erreur').forEach(function (x) { x.remove(); });
      if (avecCarte && texteCarte && !texteCarte.value.trim()) {
        var err = document.createElement('p');
        err.className = 'jp-erreur';
        err.textContent = "Merci d'écrire un petit mot pour votre carte à planter 💌";
        if (boxCarte) boxCarte.appendChild(err);
        texteCarte.focus();
        return;
      }

      var fd = new FormData(form);
      var qte = parseInt(fd.get('quantity'), 10) || 1;
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') props[m[1]] = v;
      });
      var items = [{ id: Number(fd.get('id')), quantity: qte, properties: props }];
      if (avecCarte) {
        var propsCarte = { 'Texte recto personnalisé': texteCarte.value.trim() };
        if (apercuCarte) { var pa = apercuCarte.proprietes(); for (var cp in pa) propsCarte[cp] = pa[cp]; }
        items.push({ id: CARTE_VARIANT_ID, quantity: qte, properties: propsCarte });
      }
      if (avecBoite) items.push({ id: Number(blocBoite.dataset.variantId), quantity: qte });
      if (avecSusp) items.push({ id: suspChoisie.id, quantity: qte });
      extrasPanier.forEach(function (x) { items.push({ id: x.id, quantity: qte }); });

      /* Lignes en plus ajoutées par d'autres scripts (ex. supplément prénom des fiches par occasion) */
      if (typeof window.jpItemsSupp === 'function') { try { window.jpItemsSupp(items, qte, props); } catch (er) {} }

      btn.disabled = true;
      var entetes = { 'Content-Type': 'application/json' };
      var avant = modeEdit
        ? fetch('/cart/change.js', { method: 'POST', headers: entetes, body: JSON.stringify({ id: modeEdit, quantity: 0 }) })
        : Promise.resolve();

      avant
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: entetes, body: JSON.stringify({ items: items }) });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'ajout'); }, function () { throw new Error('ajout'); });
          var pe = document.getElementById('jp-erreur-ajout'); if (pe) pe.remove();
          if (avecBoite) return fetch('/cart/update.js', { method: 'POST', headers: entetes, body: JSON.stringify({ attributes: { 'gift-wrapping': 'yes' } }) });
        })
        .then(function () { return jpApresAjout(btn); })
        .catch(function (err) {
          btn.disabled = false;
          var msg = err && err.message && err.message !== 'ajout' ? err.message : "Oups, l'ajout au panier n'a pas fonctionné. Réessayez ou écrivez-nous !";
          var pe = document.getElementById('jp-erreur-ajout');
          if (!pe) { pe = document.createElement('p'); pe.id = 'jp-erreur-ajout'; pe.className = 'jp-erreur'; pe.setAttribute('role', 'alert'); btn.parentNode.insertBefore(pe, btn); }
          pe.textContent = msg;
        });
    }, true);

    form.addEventListener('change', function (e) {
      if (occupe) return;
      if (e.target.matches && e.target.matches('.SizeSwatch__Radio, .ColorSwatch__Radio')) majOptions(false);
    });

    /* Ouvre la fenêtre photo quand le client choisit un modèle */
    if (isPot) {
      form.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var r = e.target;
        if (r.matches && r.matches('.SizeSwatch__Radio, .ColorSwatch__Radio') && r.dataset.optionPosition === '1') continuer();
      });
    }

    majOptions(true);
    try { majPrix(); } catch (e) {}
    document.documentElement.classList.add('jp-pret');
    if (plus && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { if (e[0].isIntersecting && !plus.classList.contains('jp-cache')) plusVu = true; }, { threshold: 0.4 }).observe(plus);
    }

    /* Modèle demandé dans le lien (?style=...) : appliqué une fois tout en place,
       comme si la cliente avait touché ce modèle (sans ouvrir la fenêtre photo) */
    function appliquerStyle() {
      if (!styleDemande) return;
      try {
        if (!styleDemande.checked) choisir(styleDemande);
        var b1 = styleDemande.closest('.ProductForm__Option');
        if (b1) b1.dataset.jpFait = '1';
        majOptions(true);
      } catch (e) {}
    }
    setTimeout(appliquerStyle, 50);
    window.addEventListener('load', function () { setTimeout(appliquerStyle, 300); });

    /* Variante demandée dans le lien (?variant=..., retirée de l'adresse par jp-configurateur.liquid) :
       ses options sont cochées comme si la cliente les avait choisies */
    function appliquerVariante() {
      var vid = window.JP_VARIANTE;
      if (!vid) return;
      var v = cfg.variants.filter(function (x) { return String(x.id) === String(vid); })[0];
      if (!v) { window.JP_VARIANTE = null; return; }
      try {
        for (var p = 1; p <= 3; p++) {
          var val = v['option' + p];
          if (val == null) continue;
          var r = radiosPosition(p).filter(function (x) { return x.value === val; })[0];
          if (!r) continue;
          if (!r.checked) choisir(r);
          var b = r.closest('.ProductForm__Option');
          if (b) b.dataset.jpFait = '1';
        }
        majOptions(true);
      } catch (e) {}
    }
    setTimeout(appliquerVariante, 60);
    window.addEventListener('load', function () { setTimeout(appliquerVariante, 320); });

    /* Message demandé dans le lien (?message=..., ex. page Best-sellers) : pré-rempli dans le champ texte, modifiable */
    function appliquerMessage() {
      var mUrl = new URLSearchParams(window.location.search).get('message');
      if (!mUrl || !texte || texte.value.trim()) return;
      try {
        texte.value = mUrl.slice(0, 200);
        texte.dispatchEvent(new Event('input', { bubbles: true }));
        texte.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }
    setTimeout(appliquerMessage, 400);

    /* Retour arrière (flèche du téléphone ou du navigateur) : le navigateur peut restaurer la page
       ou les choix du formulaire après coup. On recalcule alors les tailles et coupelles à afficher. */
    function resync() { if (!occupe) majOptions(true); }
    window.addEventListener('pageshow', function () { setTimeout(resync, 60); setTimeout(resync, 500); });
    window.addEventListener('load', function () { setTimeout(resync, 60); });
    window.addEventListener('popstate', function () { setTimeout(resync, 60); });
    setTimeout(resync, 700); setTimeout(resync, 1600);
  }

  function lancer() { setTimeout(init, 0); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', lancer); } else { lancer(); }
})();

})();
